export const stockCsvFilter = (tab, role, tile, content) => {
  let csv = content;
  let tileName;
  if (tile === "Accessories") {
    tileName = "Accessories";
  } else if (tile === "PARTNER BRAND") {
    tileName = "partner";
  } else {
    tileName = "other";
  }
  ({
    ZD: () => {
      ({
        "ZD": () => {
          tileName &&
            {
              Accessories: () => {
                csv =
                  content &&
                  content.map((obj) => {
                    obj["Region"] = obj["region"] ?? "";
                    obj["State"] = obj["state"] ?? "";
                    obj["ZD"] = obj["zd"] ?? "";
                    obj["ZD Name"] = obj["zdName"] ?? "";
                    obj["Brand Name"] = obj["brandDescr"] ?? "";
                    obj["Material"] = obj["maktx"] ?? "";
                    obj["Stock in units"] = obj["qty"] ?? "";
                    obj["Sales in last 90 days"] = obj["sell90Qty"] ?? "";
                    obj["Avg per day sale"] = obj["avgSales"] ?? "";
                    obj["No. of Days"] = obj["days"] ?? "";
                    delete obj["region"];
                    delete obj["state"];
                    delete obj["zd"];
                    delete obj["zdName"];
                    delete obj["rds"];
                    delete obj["rdsName"];
                    delete obj["retailer"];
                    delete obj["retailerName"];
                    delete obj["brandDescr"];
                    delete obj["model"];
                    delete obj["maktx"];
                    delete obj["jioCenter"];
                    delete obj["jcName"];
                    delete obj["qty"];
                    delete obj["sell90Qty"];
                    delete obj["avgSales"];
                    delete obj["days"];
                    return obj;
                  });
                return csv;
              },
              other: () => {
                csv =
                  content &&
                  content.map((obj) => {
                    obj["Region"] = obj["region"] ?? "";
                    obj["State"] = obj["state"] ?? "";
                    obj["ZD"] = obj["zd"] ?? "";
                    obj["ZD Name"] = obj["zdName"] ?? "";
                    obj["Brand"] = obj["brandDescr"] ?? "";
                    obj["Model"] = obj["model"] ?? "";
                    obj["Stock in units"] = obj["qty"] ?? "";
                    obj["Sales in last 90 days"] = obj["sell90Qty"] ?? "";
                    obj["Avg per day sale"] = obj["avgSales"] ?? "";
                    obj["No. of Days"] = obj["days"] ?? "";
                    delete obj["region"];
                    delete obj["state"];
                    delete obj["zd"];
                    delete obj["zdName"];
                    delete obj["rds"];
                    delete obj["rdsName"];
                    delete obj["retailer"];
                    delete obj["retailerName"];
                    delete obj["brandDescr"];
                    delete obj["model"];
                    delete obj["maktx"];
                    delete obj["jioCenter"];
                    delete obj["jcName"];
                    delete obj["qty"];
                    delete obj["sell90Qty"];
                    delete obj["avgSales"];
                    delete obj["days"];
                    return obj;
                  });
                return csv;
              },
              partner: () => {
                csv =
                  content &&
                  content.map((obj) => {
                    obj["Region"] = obj["region"] ?? "";
                    obj["State"] = obj["state"] ?? "";
                    obj["ZD"] = obj["zd"] ?? "";
                    obj["ZD Name"] = obj["zdName"] ?? "";
                    obj["Brand"] = obj["brandDescr"] ?? "";
                    obj["Model"] = obj["model"] ?? "";
                    obj["Stock in units"] = obj["qty"] ?? "";
                    obj["Sales in last 90 days"] = obj["sell90Qty"] ?? "";
                    obj["Avg per day sale"] = obj["avgSales"] ?? "";
                    obj["No. of Days"] = obj["days"] ?? "";
                    delete obj["region"];
                    delete obj["state"];
                    delete obj["zd"];
                    delete obj["zdName"];
                    delete obj["rds"];
                    delete obj["rdsName"];
                    delete obj["retailer"];
                    delete obj["retailerName"];
                    delete obj["brandDescr"];
                    delete obj["model"];
                    delete obj["maktx"];
                    delete obj["jioCenter"];
                    delete obj["jcName"];
                    delete obj["qty"];
                    delete obj["sell90Qty"];
                    delete obj["avgSales"];
                    delete obj["days"];
                    return obj;
                  });
                return csv;
              },
            }[tileName]();
          return csv;
        },
        "RDS": () => {
          tileName &&
            {
              Accessories: () => {
                csv =
                  content &&
                  content.map((obj) => {
                    obj["Region"] = obj["region"] ?? "";
                    obj["State"] = obj["state"] ?? "";
                    obj["ZD"] = obj["zd"] ?? "";
                    obj["ZD Name"] = obj["zdName"] ?? "";
                    obj["RDS"] = obj["rds"] ?? "";
                    obj["RDS Name"] = obj["rdsName"] ?? "";
                    obj["Material"] = obj["maktx"] ?? "";
                    obj["JC Code"] = obj["jioCenter"] ?? "";
                    obj["JC Name"] = obj["jcName"] ?? "";
                    obj["Stock in units"] = obj["qty"] ?? "";
                    obj["Sales in last 90 days"] = obj["sell90Qty"] ?? "";
                    obj["Avg per day sale"] = obj["avgSales"] ?? "";
                    obj["No. of Days"] = obj["days"] ?? "";
                    delete obj["region"];
                    delete obj["state"];
                    delete obj["zd"];
                    delete obj["zdName"];
                    delete obj["rds"];
                    delete obj["rdsName"];
                    delete obj["retailer"];
                    delete obj["retailerName"];
                    delete obj["brandDescr"];
                    delete obj["model"];
                    delete obj["maktx"];
                    delete obj["jioCenter"];
                    delete obj["jcName"];
                    delete obj["qty"];
                    delete obj["sell90Qty"];
                    delete obj["avgSales"];
                    delete obj["days"];
                    return obj;
                  });
                return csv;
              },
              other: () => {
                csv =
                  content &&
                  content.map((obj) => {
                    obj["Region"] = obj["region"] ?? "";
                    obj["State"] = obj["state"] ?? "";
                    obj["ZD"] = obj["zd"] ?? "";
                    obj["ZD Name"] = obj["zdName"] ?? "";
                    obj["RDS"] = obj["rds"] ?? "";
                    obj["RDS Name"] = obj["rdsName"] ?? "";
                    obj["Model"] = obj["model"] ?? "";
                    obj["JC Code"] = obj["jioCenter"] ?? "";
                    obj["JC Name"] = obj["jcName"] ?? "";
                    obj["Stock in units"] = obj["qty"] ?? "";
                    obj["Sales in last 90 days"] = obj["sell90Qty"] ?? "";
                    obj["Avg per day sale"] = obj["avgSales"] ?? "";
                    obj["No. of Days"] = obj["days"] ?? "";
                    delete obj["region"];
                    delete obj["state"];
                    delete obj["zd"];
                    delete obj["zdName"];
                    delete obj["rds"];
                    delete obj["rdsName"];
                    delete obj["retailer"];
                    delete obj["retailerName"];
                    delete obj["brandDescr"];
                    delete obj["model"];
                    delete obj["maktx"];
                    delete obj["jioCenter"];
                    delete obj["jcName"];
                    delete obj["qty"];
                    delete obj["sell90Qty"];
                    delete obj["avgSales"];
                    delete obj["days"];
                    return obj;
                  });
              },
              partner: () => {
                csv =
                  content &&
                  content.map((obj) => {
                    obj["Region"] = obj["region"] ?? "";
                    obj["State"] = obj["state"] ?? "";
                    obj["ZD"] = obj["zd"] ?? "";
                    obj["ZD Name"] = obj["zdName"] ?? "";
                    obj["RDS"] = obj["rds"] ?? "";
                    obj["RDS Name"] = obj["rdsName"] ?? "";
                    obj["Model"] = obj["model"] ?? "";
                    obj["JC Code"] = obj["jioCenter"] ?? "";
                    obj["JC Name"] = obj["jcName"] ?? "";
                    obj["Stock in units"] = obj["qty"] ?? "";
                    obj["Sales in last 90 days"] = obj["sell90Qty"] ?? "";
                    obj["Avg per day sale"] = obj["avgSales"] ?? "";
                    obj["No. of Days"] = obj["days"] ?? "";
                    delete obj["region"];
                    delete obj["state"];
                    delete obj["zd"];
                    delete obj["zdName"];
                    delete obj["rds"];
                    delete obj["rdsName"];
                    delete obj["retailer"];
                    delete obj["retailerName"];
                    delete obj["brandDescr"];
                    delete obj["model"];
                    delete obj["maktx"];
                    delete obj["jioCenter"];
                    delete obj["jcName"];
                    delete obj["qty"];
                    delete obj["sell90Qty"];
                    delete obj["avgSales"];
                    delete obj["days"];
                    return obj;
                  });
                return csv;
              },
            }[tileName]();
        },
        "Retailer": () => {
          tileName &&
            {
              Accessories: () => {
                csv =
                  content &&
                  content.map((obj) => {
                    obj["Region"] = obj["region"] ?? "";
                    obj["State"] = obj["state"] ?? "";
                    obj["ZD"] = obj["zd"] ?? "";
                    obj["ZD Name"] = obj["zdName"] ?? "";
                    obj["RDS"] = obj["rds"] ?? "";
                    obj["RDS Name"] = obj["rdsName"] ?? "";
                    obj["Retailer ID"] = obj["retailer"] ?? "";
                    obj["Retailer Name"] = obj["retailerName"] ?? "";
                    obj["Model"] = obj["model"] ?? "";
                    obj["JC Code"] = obj["jioCenter"] ?? "";
                    obj["JC Name"] = obj["jcName"] ?? "";
                    obj["Stock in units"] = obj["qty"] ?? "";
                    obj["Sales in last 90 days"] = obj["sell90Qty"] ?? "";
                    obj["Avg per day sale"] = obj["avgSales"] ?? "";
                    obj["No. of Days"] = obj["days"] ?? "";
                    delete obj["region"];
                    delete obj["state"];
                    delete obj["zd"];
                    delete obj["zdName"];
                    delete obj["rds"];
                    delete obj["rdsName"];
                    delete obj["retailer"];
                    delete obj["retailerName"];
                    delete obj["brandDescr"];
                    delete obj["model"];
                    delete obj["maktx"];
                    delete obj["jioCenter"];
                    delete obj["jcName"];
                    delete obj["qty"];
                    delete obj["sell90Qty"];
                    delete obj["avgSales"];
                    delete obj["days"];
                    return obj;
                  });
              },
              other: () => {
                csv =
                  content &&
                  content.map((obj) => {
                    obj["Region"] = obj["region"] ?? "";
                    obj["State"] = obj["state"] ?? "";
                    obj["ZD"] = obj["zd"] ?? "";
                    obj["ZD Name"] = obj["zdName"] ?? "";
                    obj["RDS"] = obj["rds"] ?? "";
                    obj["RDS Name"] = obj["rdsName"] ?? "";
                    obj["Retailer ID"] = obj["retailer"] ?? "";
                    obj["Retailer Name"] = obj["retailerName"] ?? "";
                    obj["Model"] = obj["model"] ?? "";
                    obj["JC Code"] = obj["jioCenter"] ?? "";
                    obj["JC Name"] = obj["jcName"] ?? "";
                    obj["Stock in units"] = obj["qty"] ?? "";
                    obj["Sales in last 90 days"] = obj["sell90Qty"] ?? "";
                    obj["Avg per day sale"] = obj["avgSales"] ?? "";
                    obj["No. of Days"] = obj["days"] ?? "";
                    delete obj["region"];
                    delete obj["state"];
                    delete obj["zd"];
                    delete obj["zdName"];
                    delete obj["rds"];
                    delete obj["rdsName"];
                    delete obj["retailer"];
                    delete obj["retailerName"];
                    delete obj["brandDescr"];
                    delete obj["model"];
                    delete obj["maktx"];
                    delete obj["jioCenter"];
                    delete obj["jcName"];
                    delete obj["qty"];
                    delete obj["sell90Qty"];
                    delete obj["avgSales"];
                    delete obj["days"];
                    return obj;
                  });
                return csv;
              },
              partner: () => {
                csv =
                  content &&
                  content.map((obj) => {
                    obj["Region"] = obj["region"] ?? "";
                    obj["State"] = obj["state"] ?? "";
                    obj["ZD"] = obj["zd"] ?? "";
                    obj["ZD Name"] = obj["zdName"] ?? "";
                    obj["RDS"] = obj["rds"] ?? "";
                    obj["RDS Name"] = obj["rdsName"] ?? "";
                    obj["Retailer ID"] = obj["retailer"] ?? "";
                    obj["Retailer Name"] = obj["retailerName"] ?? "";
                    obj["Model"] = obj["model"] ?? "";
                    obj["JC Code"] = obj["jioCenter"] ?? "";
                    obj["JC Name"] = obj["jcName"] ?? "";
                    obj["Stock in units"] = obj["qty"] ?? "";
                    obj["Sales in last 90 days"] = obj["sell90Qty"] ?? "";
                    obj["Avg per day sale"] = obj["avgSales"] ?? "";
                    obj["No. of Days"] = obj["days"] ?? "";
                    delete obj["region"];
                    delete obj["state"];
                    delete obj["zd"];
                    delete obj["zdName"];
                    delete obj["rds"];
                    delete obj["rdsName"];
                    delete obj["retailer"];
                    delete obj["retailerName"];
                    delete obj["brandDescr"];
                    delete obj["model"];
                    delete obj["maktx"];
                    delete obj["jioCenter"];
                    delete obj["jcName"];
                    delete obj["qty"];
                    delete obj["sell90Qty"];
                    delete obj["avgSales"];
                    delete obj["days"];
                    return obj;
                  });
                return csv;
              },
            }[tileName]();
        },
      }[tab]());
      return csv;
    },
    RDS: () => {
      ({
        "RDS": () => {
          tileName &&
            {
              Accessories: () => {
                csv =
                  content &&
                  content.map((obj) => {
                    obj["Region"] = obj["region"] ?? "";
                    obj["State"] = obj["state"] ?? "";
                    obj["ZD"] = obj["zd"] ?? "";
                    obj["ZD Name"] = obj["zdName"] ?? "";
                    obj["RDS"] = obj["rds"] ?? "";
                    obj["RDS Name"] = obj["rdsName"] ?? "";
                    obj["Brand"] = obj["brandDescr"] ?? "";
                    obj["Material"] = obj["maktx"] ?? "";
                    obj["JC Code"] = obj["jioCenter"] ?? "";
                    obj["JC Name"] = obj["jcName"] ?? "";
                    obj["Stock in units"] = obj["qty"] ?? "";
                    obj["Sales in last 90 days"] = obj["sell90Qty"] ?? "";
                    obj["Avg per day sale"] = obj["avgSales"] ?? "";
                    obj["No. of Days"] = obj["days"] ?? "";
                    delete obj["region"];
                    delete obj["state"];
                    delete obj["zd"];
                    delete obj["zdName"];
                    delete obj["rds"];
                    delete obj["rdsName"];
                    delete obj["retailer"];
                    delete obj["retailerName"];
                    delete obj["brandDescr"];
                    delete obj["model"];
                    delete obj["maktx"];
                    delete obj["jioCenter"];
                    delete obj["jcName"];
                    delete obj["qty"];
                    delete obj["sell90Qty"];
                    delete obj["avgSales"];
                    delete obj["days"];
                    return obj;
                  });
                return csv;
              },
              other: () => {
                csv =
                  content &&
                  content.map((obj) => {
                    obj["Region"] = obj["region"] ?? "";
                    obj["State"] = obj["state"] ?? "";
                    obj["ZD"] = obj["zd"] ?? "";
                    obj["ZD Name"] = obj["zdName"] ?? "";
                    obj["RDS"] = obj["rds"] ?? "";
                    obj["RDS Name"] = obj["rdsName"] ?? "";
                    obj["Brand"] = obj["brandDescr"] ?? "";
                    obj["Model"] = obj["model"] ?? "";
                    obj["JC Code"] = obj["jioCenter"] ?? "";
                    obj["JC Name"] = obj["jcName"] ?? "";
                    obj["Stock in units"] = obj["qty"] ?? "";
                    obj["Sales in last 90 days"] = obj["sell90Qty"] ?? "";
                    obj["Avg per day sale"] = obj["avgSales"] ?? "";
                    obj["No. of Days"] = obj["days"] ?? "";
                    delete obj["region"];
                    delete obj["state"];
                    delete obj["zd"];
                    delete obj["zdName"];
                    delete obj["rds"];
                    delete obj["rdsName"];
                    delete obj["retailer"];
                    delete obj["retailerName"];
                    delete obj["brandDescr"];
                    delete obj["model"];
                    delete obj["maktx"];
                    delete obj["jioCenter"];
                    delete obj["jcName"];
                    delete obj["qty"];
                    delete obj["sell90Qty"];
                    delete obj["avgSales"];
                    delete obj["days"];
                    return obj;
                  });
                return csv;
              },
              partner: () => {
                csv =
                  content &&
                  content.map((obj) => {
                    obj["Region"] = obj["region"] ?? "";
                    obj["State"] = obj["state"] ?? "";
                    obj["ZD"] = obj["zd"] ?? "";
                    obj["ZD Name"] = obj["zdName"] ?? "";
                    obj["RDS"] = obj["rds"] ?? "";
                    obj["RDS Name"] = obj["rdsName"] ?? "";
                    obj["Brand"] = obj["brandDescr"] ?? "";
                    obj["Model"] = obj["model"] ?? "";
                    obj["JC Code"] = obj["jioCenter"] ?? "";
                    obj["JC Name"] = obj["jcName"] ?? "";
                    obj["Stock in units"] = obj["qty"] ?? "";
                    obj["Sales in last 90 days"] = obj["sell90Qty"] ?? "";
                    obj["Avg per day sale"] = obj["avgSales"] ?? "";
                    obj["No. of Days"] = obj["days"] ?? "";
                    delete obj["region"];
                    delete obj["state"];
                    delete obj["zd"];
                    delete obj["zdName"];
                    delete obj["rds"];
                    delete obj["rdsName"];
                    delete obj["retailer"];
                    delete obj["retailerName"];
                    delete obj["brandDescr"];
                    delete obj["model"];
                    delete obj["maktx"];
                    delete obj["jioCenter"];
                    delete obj["jcName"];
                    delete obj["qty"];
                    delete obj["sell90Qty"];
                    delete obj["avgSales"];
                    delete obj["days"];
                    return obj;
                  });
                return csv;
              },
            }[tileName]();
        },
        "Retailer": () => {
          tileName &&
            {
              Accessories: () => {
                csv =
                  content &&
                  content.map((obj) => {
                    obj["Region"] = obj["region"] ?? "";
                    obj["State"] = obj["state"] ?? "";
                    obj["ZD"] = obj["zd"] ?? "";
                    obj["ZD Name"] = obj["zdName"] ?? "";
                    obj["RDS"] = obj["rds"] ?? "";
                    obj["RDS Name"] = obj["rdsName"] ?? "";
                    obj["Retailer ID"] = obj["retailer"] ?? "";
                    obj["Retailer Name"] = obj["retailerName"] ?? "";
                    obj["Model"] = obj["model"] ?? "";
                    obj["JC Code"] = obj["jioCenter"] ?? "";
                    obj["JC Name"] = obj["jcName"] ?? "";
                    obj["Stock in units"] = obj["qty"] ?? "";
                    obj["Sales in last 90 days"] = obj["sell90Qty"] ?? "";
                    obj["Avg per day sale"] = obj["avgSales"] ?? "";
                    obj["No. of Days"] = obj["days"] ?? "";
                    delete obj["region"];
                    delete obj["state"];
                    delete obj["zd"];
                    delete obj["zdName"];
                    delete obj["rds"];
                    delete obj["rdsName"];
                    delete obj["retailer"];
                    delete obj["retailerName"];
                    delete obj["brandDescr"];
                    delete obj["model"];
                    delete obj["maktx"];
                    delete obj["jioCenter"];
                    delete obj["jcName"];
                    delete obj["qty"];
                    delete obj["sell90Qty"];
                    delete obj["avgSales"];
                    delete obj["days"];
                    return obj;
                  });
                return csv;
              },
              other: () => {
                csv =
                  content &&
                  content.map((obj) => {
                    obj["Region"] = obj["region"] ?? "";
                    obj["State"] = obj["state"] ?? "";
                    obj["ZD"] = obj["zd"] ?? "";
                    obj["ZD Name"] = obj["zdName"] ?? "";
                    obj["RDS"] = obj["rds"] ?? "";
                    obj["RDS Name"] = obj["rdsName"] ?? "";
                    obj["Retailer ID"] = obj["retailer"] ?? "";
                    obj["Retailer Name"] = obj["retailerName"] ?? "";
                    obj["Model"] = obj["model"] ?? "";
                    obj["JC Code"] = obj["jioCenter"] ?? "";
                    obj["JC Name"] = obj["jcName"] ?? "";
                    obj["Stock in units"] = obj["qty"] ?? "";
                    obj["Sales in last 90 days"] = obj["sell90Qty"] ?? "";
                    obj["Avg per day sale"] = obj["avgSales"] ?? "";
                    obj["No. of Days"] = obj["days"] ?? "";
                    delete obj["region"];
                    delete obj["state"];
                    delete obj["zd"];
                    delete obj["zdName"];
                    delete obj["rds"];
                    delete obj["rdsName"];
                    delete obj["retailer"];
                    delete obj["retailerName"];
                    delete obj["brandDescr"];
                    delete obj["model"];
                    delete obj["maktx"];
                    delete obj["jioCenter"];
                    delete obj["jcName"];
                    delete obj["qty"];
                    delete obj["sell90Qty"];
                    delete obj["avgSales"];
                    delete obj["days"];
                    return obj;
                  });
                return csv;
              },
              partner: () => {
                csv =
                  content &&
                  content.map((obj) => {
                    obj["Region"] = obj["region"] ?? "";
                    obj["State"] = obj["state"] ?? "";
                    obj["ZD"] = obj["zd"] ?? "";
                    obj["ZD Name"] = obj["zdName"] ?? "";
                    obj["RDS"] = obj["rds"] ?? "";
                    obj["RDS Name"] = obj["rdsName"] ?? "";
                    obj["Retailer ID"] = obj["retailer"] ?? "";
                    obj["Retailer Name"] = obj["retailerName"] ?? "";
                    obj["Model"] = obj["model"] ?? "";
                    obj["JC Code"] = obj["jioCenter"] ?? "";
                    obj["JC Name"] = obj["jcName"] ?? "";
                    obj["Stock in units"] = obj["qty"] ?? "";
                    obj["Sales in last 90 days"] = obj["sell90Qty"] ?? "";
                    obj["Avg per day sale"] = obj["avgSales"] ?? "";
                    obj["No. of Days"] = obj["days"] ?? "";
                    delete obj["region"];
                    delete obj["state"];
                    delete obj["zd"];
                    delete obj["zdName"];
                    delete obj["rds"];
                    delete obj["rdsName"];
                    delete obj["retailer"];
                    delete obj["retailerName"];
                    delete obj["brandDescr"];
                    delete obj["model"];
                    delete obj["maktx"];
                    delete obj["jioCenter"];
                    delete obj["jcName"];
                    delete obj["qty"];
                    delete obj["sell90Qty"];
                    delete obj["avgSales"];
                    delete obj["days"];
                    return obj;
                  });
                return csv;
              },
            }[tileName]();
        },
      }[tab]());
    },
    ITZ: () => {
      ({
        "ITZD": () => {
          tileName &&
            {
              Accessories: () => {
                csv =
                  content &&
                  content.map((obj) => {
                    obj["Region"] = obj["region"] ?? "";
                    obj["State Name"] = obj["state"] ?? "";
                    obj["IT ZD Code"] = obj["zd"] ?? "";
                    obj["IT ZD Name"] = obj["zdName"] ?? "";
                    obj["Brand Description"] = obj["brandDescr"] ?? "";
                    obj["Material"] = obj["maktx"] ?? "";
                    obj["JC Code"] = obj["jioCenter"] ?? "";
                    obj["JC Name"] = obj["jcName"] ?? "";
                    obj["QTY"] = obj["qty"] ?? "";
                    obj["Sales In Last 90 Days"] = obj["sell90Qty"] ?? "";
                    obj["Avg Sales"] = obj["avgSales"] ?? "";
                    obj["No of Days"] = obj["days"] ?? "";
                    delete obj["region"];
                    delete obj["state"];
                    delete obj["zd"];
                    delete obj["zdName"];
                    delete obj["rds"];
                    delete obj["rdsName"];
                    delete obj["retailer"];
                    delete obj["retailerName"];
                    delete obj["brandDescr"];
                    delete obj["model"];
                    delete obj["maktx"];
                    delete obj["jioCenter"];
                    delete obj["jcName"];
                    delete obj["qty"];
                    delete obj["sell90Qty"];
                    delete obj["avgSales"];
                    delete obj["days"];
                    return obj;
                  });
                return csv;
              },
              other: () => {
                csv =
                  content &&
                  content.map((obj) => {
                    obj["Region"] = obj["region"] ?? "";
                    obj["State Name"] = obj["state"] ?? "";
                    obj["IT ZD Code"] = obj["zd"] ?? "";
                    obj["IT ZD Name"] = obj["zdName"] ?? "";
                    obj["Brand Description"] = obj["brandDescr"] ?? "";
                    obj["Model"] = obj["model"] ?? "";
                    obj["JC Code"] = obj["jioCenter"] ?? "";
                    obj["JC Name"] = obj["jcName"] ?? "";
                    obj["QTY"] = obj["qty"] ?? "";
                    obj["Sales In Last 90 Days"] = obj["sell90Qty"] ?? "";
                    obj["Avg Sales"] = obj["avgSales"] ?? "";
                    obj["No of Days"] = obj["days"] ?? "";
                    delete obj["region"];
                    delete obj["state"];
                    delete obj["zd"];
                    delete obj["zdName"];
                    delete obj["rds"];
                    delete obj["rdsName"];
                    delete obj["retailer"];
                    delete obj["retailerName"];
                    delete obj["brandDescr"];
                    delete obj["model"];
                    delete obj["maktx"];
                    delete obj["jioCenter"];
                    delete obj["jcName"];
                    delete obj["qty"];
                    delete obj["sell90Qty"];
                    delete obj["avgSales"];
                    delete obj["days"];
                    return obj;
                  });
                return csv;
              },
              partner: () => {
                csv =
                  content &&
                  content.map((obj) => {
                    obj["Region"] = obj["region"] ?? "";
                    obj["State Name"] = obj["state"] ?? "";
                    obj["IT ZD Code"] = obj["zd"] ?? "";
                    obj["IT ZD Name"] = obj["zdName"] ?? "";
                    obj["Brand Description"] = obj["brandDescr"] ?? "";
                    obj["Model"] = obj["model"] ?? "";
                    obj["QTY"] = obj["qty"] ?? "";
                    obj["Sales In Last 90 Days"] = obj["sell90Qty"] ?? "";
                    obj["Avg Sales"] = obj["avgSales"] ?? "";
                    obj["No of Days"] = obj["days"] ?? "";
                    delete obj["region"];
                    delete obj["state"];
                    delete obj["zd"];
                    delete obj["zdName"];
                    delete obj["rds"];
                    delete obj["rdsName"];
                    delete obj["retailer"];
                    delete obj["retailerName"];
                    delete obj["brandDescr"];
                    delete obj["model"];
                    delete obj["maktx"];
                    delete obj["jioCenter"];
                    delete obj["jcName"];
                    delete obj["qty"];
                    delete obj["sell90Qty"];
                    delete obj["avgSales"];
                    delete obj["days"];
                    return obj;
                  });
                return csv;
              },
            }[tileName]();
        },
        "ITD": () => {
          tileName &&
            {
              Accessories: () => {
                csv =
                  content &&
                  content.map((obj) => {
                    obj["Region"] = obj["region"] ?? "";
                    obj["State Name"] = obj["state"] ?? "";
                    obj["IT ZD Code"] = obj["zd"] ?? "";
                    obj["IT ZD Name"] = obj["zdName"] ?? "";
                    obj["IT RDS"] = obj["rds"] ?? "";
                    obj["IT RDS Name"] = obj["rdsName"] ?? "";
                    obj["Brand Description"] = obj["brandDescr"] ?? "";
                    obj["Material"] = obj["maktx"] ?? "";
                    obj["JC Code"] = obj["jioCenter"] ?? "";
                    obj["JC Name"] = obj["jcName"] ?? "";
                    obj["QTY"] = obj["qty"] ?? "";
                    obj["Sales In Last 90 Days"] = obj["sell90Qty"] ?? "";
                    obj["Avg Sales"] = obj["avgSales"] ?? "";
                    obj["No of Days"] = obj["days"] ?? "";
                    delete obj["region"];
                    delete obj["state"];
                    delete obj["zd"];
                    delete obj["zdName"];
                    delete obj["rds"];
                    delete obj["rdsName"];
                    delete obj["retailer"];
                    delete obj["retailerName"];
                    delete obj["brandDescr"];
                    delete obj["model"];
                    delete obj["maktx"];
                    delete obj["jioCenter"];
                    delete obj["jcName"];
                    delete obj["qty"];
                    delete obj["sell90Qty"];
                    delete obj["avgSales"];
                    delete obj["days"];
                    return obj;
                  });
                return csv;
              },
              other: () => {
                csv =
                  content &&
                  content.map((obj) => {
                    obj["Region"] = obj["region"] ?? "";
                    obj["State Name"] = obj["state"] ?? "";
                    obj["IT ZD Code"] = obj["zd"] ?? "";
                    obj["IT ZD Name"] = obj["zdName"] ?? "";
                    obj["IT RDS"] = obj["rds"] ?? "";
                    obj["IT RDS Name"] = obj["rdsName"] ?? "";
                    obj["Brand Description"] = obj["brandDescr"] ?? "";
                    obj["Model"] = obj["model"] ?? "";
                    obj["JC Code"] = obj["jioCenter"] ?? "";
                    obj["JC Name"] = obj["jcName"] ?? "";
                    obj["QTY"] = obj["qty"] ?? "";
                    obj["Sales In Last 90 Days"] = obj["sell90Qty"] ?? "";
                    obj["Avg Sales"] = obj["avgSales"] ?? "";
                    obj["No of Days"] = obj["days"] ?? "";
                    delete obj["region"];
                    delete obj["state"];
                    delete obj["zd"];
                    delete obj["zdName"];
                    delete obj["rds"];
                    delete obj["rdsName"];
                    delete obj["retailer"];
                    delete obj["retailerName"];
                    delete obj["brandDescr"];
                    delete obj["model"];
                    delete obj["maktx"];
                    delete obj["jioCenter"];
                    delete obj["jcName"];
                    delete obj["qty"];
                    delete obj["sell90Qty"];
                    delete obj["avgSales"];
                    delete obj["days"];
                    return obj;
                  });
                return csv;
              },
              partner: () => {
                csv =
                  content &&
                  content.map((obj) => {
                    obj["Region"] = obj["region"] ?? "";
                    obj["State Name"] = obj["state"] ?? "";
                    obj["IT ZD Code"] = obj["zd"] ?? "";
                    obj["IT ZD Name"] = obj["zdName"] ?? "";
                    obj["IT RDS"] = obj["rds"] ?? "";
                    obj["IT RDS Name"] = obj["rdsName"] ?? "";
                    obj["Brand Description"] = obj["brandDescr"] ?? "";
                    obj["Model"] = obj["model"] ?? "";
                    obj["JC Code"] = obj["jioCenter"] ?? "";
                    obj["JC Name"] = obj["jcName"] ?? "";
                    obj["Stock in units"] = obj["qty"] ?? "";
                    obj["Sales In Last 90 Days"] = obj["sell90Qty"] ?? "";
                    obj["Avg Sales"] = obj["avgSales"] ?? "";
                    obj["No of Days"] = obj["days"] ?? "";
                    delete obj["region"];
                    delete obj["state"];
                    delete obj["zd"];
                    delete obj["zdName"];
                    delete obj["rds"];
                    delete obj["rdsName"];
                    delete obj["retailer"];
                    delete obj["retailerName"];
                    delete obj["brandDescr"];
                    delete obj["model"];
                    delete obj["maktx"];
                    delete obj["jioCenter"];
                    delete obj["jcName"];
                    delete obj["qty"];
                    delete obj["sell90Qty"];
                    delete obj["avgSales"];
                    delete obj["days"];
                    return obj;
                  });
                return csv;
              },
            }[tileName]();
        },
        "Retailer": () => {
          tileName &&
            {
              Accessories: () => {
                csv =
                  content &&
                  content.map((obj) => {
                    obj["Region"] = obj["region"] ?? "";
                    obj["State Name"] = obj["state"] ?? "";
                    obj["IT ZD Code"] = obj["zd"] ?? "";
                    obj["IT ZD Name"] = obj["zdName"] ?? "";
                    obj["IT RDS"] = obj["rds"] ?? "";
                    obj["IT RDS Name"] = obj["rdsName"] ?? "";
                    obj["Retailer ID"] = obj["retailer"] ?? "";
                    obj["Retailer Name"] = obj["retailerName"] ?? "";
                    obj["Model"] = obj["model"] ?? "";
                    obj["JC Code"] = obj["jioCenter"] ?? "";
                    obj["JC Name"] = obj["jcName"] ?? "";
                    obj["Stock in units"] = obj["qty"] ?? "";
                    obj["Sales In Last 90 Days"] = obj["sell90Qty"] ?? "";
                    obj["Avg per day Sales"] = obj["avgSales"] ?? "";
                    obj["No of Days"] = obj["days"] ?? "";
                    delete obj["region"];
                    delete obj["state"];
                    delete obj["zd"];
                    delete obj["zdName"];
                    delete obj["rds"];
                    delete obj["rdsName"];
                    delete obj["retailer"];
                    delete obj["retailerName"];
                    delete obj["brandDescr"];
                    delete obj["model"];
                    delete obj["maktx"];
                    delete obj["jioCenter"];
                    delete obj["jcName"];
                    delete obj["qty"];
                    delete obj["sell90Qty"];
                    delete obj["avgSales"];
                    delete obj["days"];
                    return obj;
                  });
                return csv;
              },
              other: () => {
                csv =
                  content &&
                  content.map((obj) => {
                    obj["Region"] = obj["region"] ?? "";
                    obj["State Name"] = obj["state"] ?? "";
                    obj["IT ZD Code"] = obj["zd"] ?? "";
                    obj["IT ZD Name"] = obj["zdName"] ?? "";
                    obj["IT RDS"] = obj["rds"] ?? "";
                    obj["IT RDS Name"] = obj["rdsName"] ?? "";
                    obj["Retailer ID"] = obj["retailer"] ?? "";
                    obj["Retailer Name"] = obj["retailerName"] ?? "";
                    obj["Model"] = obj["model"] ?? "";
                    obj["JC Code"] = obj["jioCenter"] ?? "";
                    obj["JC Name"] = obj["jcName"] ?? "";
                    obj["Stock in units"] = obj["qty"] ?? "";
                    obj["Sales In Last 90 Days"] = obj["sell90Qty"] ?? "";
                    obj["Avg per day Sales"] = obj["avgSales"] ?? "";
                    obj["No of Days"] = obj["days"] ?? "";
                    delete obj["region"];
                    delete obj["state"];
                    delete obj["zd"];
                    delete obj["zdName"];
                    delete obj["rds"];
                    delete obj["rdsName"];
                    delete obj["retailer"];
                    delete obj["retailerName"];
                    delete obj["brandDescr"];
                    delete obj["model"];
                    delete obj["maktx"];
                    delete obj["jioCenter"];
                    delete obj["jcName"];
                    delete obj["qty"];
                    delete obj["sell90Qty"];
                    delete obj["avgSales"];
                    delete obj["days"];
                    return obj;
                  });
                return csv;
              },
              partner: () => {
                csv =
                  content &&
                  content.map((obj) => {
                    obj["Region"] = obj["region"] ?? "";
                    obj["State Name"] = obj["state"] ?? "";
                    obj["IT ZD Code"] = obj["zd"] ?? "";
                    obj["IT ZD Name"] = obj["zdName"] ?? "";
                    obj["IT RDS"] = obj["rds"] ?? "";
                    obj["IT RDS Name"] = obj["rdsName"] ?? "";
                    obj["Retailer ID"] = obj["retailer"] ?? "";
                    obj["Retailer Name"] = obj["retailerName"] ?? "";
                    obj["Model"] = obj["model"] ?? "";
                    obj["JC Code"] = obj["jioCenter"] ?? "";
                    obj["JC Name"] = obj["jcName"] ?? "";
                    obj["Stock in units"] = obj["qty"] ?? "";
                    obj["Sales In Last 90 Days"] = obj["sell90Qty"] ?? "";
                    obj["Avg per day Sales"] = obj["avgSales"] ?? "";
                    obj["No of Days"] = obj["days"] ?? "";
                    delete obj["region"];
                    delete obj["state"];
                    delete obj["zd"];
                    delete obj["zdName"];
                    delete obj["rds"];
                    delete obj["rdsName"];
                    delete obj["retailer"];
                    delete obj["retailerName"];
                    delete obj["brandDescr"];
                    delete obj["model"];
                    delete obj["maktx"];
                    delete obj["jioCenter"];
                    delete obj["jcName"];
                    delete obj["qty"];
                    delete obj["sell90Qty"];
                    delete obj["avgSales"];
                    delete obj["days"];
                    return obj;
                  });
                return csv;
              },
            }[tileName]();
        },
      }[tab]());
      return csv;
    },
    ITD: () => {
      ({
        "ITD": () => {
          tileName &&
            {
              Accessories: () => {
                csv =
                  content &&
                  content.map((obj) => {
                    obj["Region"] = obj["region"] ?? "";
                    obj["State"] = obj["state"] ?? "";
                    obj["ITD Code"] = obj["rds"] ?? "";
                    obj["ITD Name"] = obj["rdsName"] ?? "";
                    obj["Brand Description"] = obj["brandDescr"] ?? "";
                    obj["Material"] = obj["maktx"] ?? "";
                    obj["JC Code"] = obj["jioCenter"] ?? "";
                    obj["JC Name"] = obj["jcName"] ?? "";
                    obj["Stock in units(114)"] = obj["qty"] ?? "";
                    obj["Sales In Last 90 Days"] = obj["sell90Qty"] ?? "";
                    obj["Avg per day Sales"] = obj["avgSales"] ?? "";
                    obj["No of Days"] = obj["days"] ?? "";
                    delete obj["region"];
                    delete obj["state"];
                    delete obj["zd"];
                    delete obj["zdName"];
                    delete obj["rds"];
                    delete obj["rdsName"];
                    delete obj["retailer"];
                    delete obj["retailerName"];
                    delete obj["brandDescr"];
                    delete obj["model"];
                    delete obj["maktx"];
                    delete obj["jioCenter"];
                    delete obj["jcName"];
                    delete obj["qty"];
                    delete obj["sell90Qty"];
                    delete obj["avgSales"];
                    delete obj["days"];
                    return obj;
                  });
                return csv;
              },
              other: () => {
                csv =
                  content &&
                  content.map((obj) => {
                    obj["Region"] = obj["region"] ?? "";
                    obj["State"] = obj["state"] ?? "";
                    obj["ITD Code"] = obj["rds"] ?? "";
                    obj["ITD Name"] = obj["rdsName"] ?? "";
                    obj["Brand Description"] = obj["brandDescr"] ?? "";
                    obj["Model"] = obj["model"] ?? "";
                    obj["JC Code"] = obj["jioCenter"] ?? "";
                    obj["JC Name"] = obj["jcName"] ?? "";
                    obj["Stock in units(114)"] = obj["qty"] ?? "";
                    obj["Sales In Last 90 Days"] = obj["sell90Qty"] ?? "";
                    obj["Avg per day Sales"] = obj["avgSales"] ?? "";
                    obj["No of Days"] = obj["days"] ?? "";
                    delete obj["region"];
                    delete obj["state"];
                    delete obj["zd"];
                    delete obj["zdName"];
                    delete obj["rds"];
                    delete obj["rdsName"];
                    delete obj["retailer"];
                    delete obj["retailerName"];
                    delete obj["brandDescr"];
                    delete obj["model"];
                    delete obj["maktx"];
                    delete obj["jioCenter"];
                    delete obj["jcName"];
                    delete obj["qty"];
                    delete obj["sell90Qty"];
                    delete obj["avgSales"];
                    delete obj["days"];
                    return obj;
                  });
                return csv;
              },
              partner: () => {
                csv =
                  content &&
                  content.map((obj) => {
                    obj["Region"] = obj["region"] ?? "";
                    obj["State"] = obj["state"] ?? "";
                    obj["ITD Code"] = obj["rds"] ?? "";
                    obj["ITD Name"] = obj["rdsName"] ?? "";
                    obj["Brand Description"] = obj["brandDescr"] ?? "";
                    obj["Model"] = obj["model"] ?? "";
                    obj["JC Code"] = obj["jioCenter"] ?? "";
                    obj["JC Name"] = obj["jcName"] ?? "";
                    obj["Stock in units(114)"] = obj["qty"] ?? "";
                    obj["Sales In Last 90 Days"] = obj["sell90Qty"] ?? "";
                    obj["Avg per day Sales"] = obj["avgSales"] ?? "";
                    obj["No of Days"] = obj["days"] ?? "";
                    delete obj["region"];
                    delete obj["state"];
                    delete obj["zd"];
                    delete obj["zdName"];
                    delete obj["rds"];
                    delete obj["rdsName"];
                    delete obj["retailer"];
                    delete obj["retailerName"];
                    delete obj["brandDescr"];
                    delete obj["model"];
                    delete obj["maktx"];
                    delete obj["jioCenter"];
                    delete obj["jcName"];
                    delete obj["qty"];
                    delete obj["sell90Qty"];
                    delete obj["avgSales"];
                    delete obj["days"];
                    return obj;
                  });
                return csv;
              },
            }[tileName]();
        },
        "Retailer": () => {
          tileName &&
            {
              Accessories: () => {
                csv =
                  content &&
                  content.map((obj) => {
                    obj["Region"] = obj["region"] ?? "";
                    obj["State"] = obj["state"] ?? "";
                    obj["IT ZD"] = obj["zd"] ?? "";
                    obj["IT ZD Name"] = obj["zdName"] ?? "";
                    obj["IT RDS"] = obj["rds"] ?? "";
                    obj["IT RDS Name"] = obj["rdsName"] ?? "";
                    obj["Retailer ID"] = obj["retailer"] ?? "";
                    obj["Retailer Name"] = obj["retailerName"] ?? "";
                    obj["Model"] = obj["model"] ?? "";
                    obj["JC Code"] = obj["jioCenter"] ?? "";
                    obj["JC Name"] = obj["jcName"] ?? "";
                    obj["Stock in units(114)"] = obj["qty"] ?? "";
                    obj["Sales In Last 90 Days"] = obj["sell90Qty"] ?? "";
                    obj["Avg per day Sales"] = obj["avgSales"] ?? "";
                    obj["No of Days"] = obj["days"] ?? "";
                    delete obj["region"];
                    delete obj["state"];
                    delete obj["zd"];
                    delete obj["zdName"];
                    delete obj["rds"];
                    delete obj["rdsName"];
                    delete obj["retailer"];
                    delete obj["retailerName"];
                    delete obj["brandDescr"];
                    delete obj["model"];
                    delete obj["maktx"];
                    delete obj["jioCenter"];
                    delete obj["jcName"];
                    delete obj["qty"];
                    delete obj["sell90Qty"];
                    delete obj["avgSales"];
                    delete obj["days"];
                    return obj;
                  });
                return csv;
              },
              other: () => {
                csv =
                  content &&
                  content.map((obj) => {
                    obj["Region"] = obj["region"] ?? "";
                    obj["State"] = obj["state"] ?? "";
                    obj["IT ZD"] = obj["zd"] ?? "";
                    obj["IT ZD Name"] = obj["zdName"] ?? "";
                    obj["IT RDS"] = obj["rds"] ?? "";
                    obj["IT RDS Name"] = obj["rdsName"] ?? "";
                    obj["Retailer ID"] = obj["retailer"] ?? "";
                    obj["Retailer Name"] = obj["retailerName"] ?? "";
                    obj["Model"] = obj["model"] ?? "";
                    obj["JC Code"] = obj["jioCenter"] ?? "";
                    obj["JC Name"] = obj["jcName"] ?? "";
                    obj["Stock in units(114)"] = obj["qty"] ?? "";
                    obj["Sales In Last 90 Days"] = obj["sell90Qty"] ?? "";
                    obj["Avg per day Sales"] = obj["avgSales"] ?? "";
                    obj["No of Days"] = obj["days"] ?? "";
                    delete obj["region"];
                    delete obj["state"];
                    delete obj["zd"];
                    delete obj["zdName"];
                    delete obj["rds"];
                    delete obj["rdsName"];
                    delete obj["retailer"];
                    delete obj["retailerName"];
                    delete obj["brandDescr"];
                    delete obj["model"];
                    delete obj["maktx"];
                    delete obj["jioCenter"];
                    delete obj["jcName"];
                    delete obj["qty"];
                    delete obj["sell90Qty"];
                    delete obj["avgSales"];
                    delete obj["days"];
                    return obj;
                  });
                return csv;
              },
              partner: () => {
                csv =
                  content &&
                  content.map((obj) => {
                    obj["Region"] = obj["region"] ?? "";
                    obj["State"] = obj["state"] ?? "";
                    obj["IT ZD"] = obj["zd"] ?? "";
                    obj["IT ZD Name"] = obj["zdName"] ?? "";
                    obj["IT RDS"] = obj["rds"] ?? "";
                    obj["IT RDS Name"] = obj["rdsName"] ?? "";
                    obj["Retailer ID"] = obj["retailer"] ?? "";
                    obj["Retailer Name"] = obj["retailerName"] ?? "";
                    obj["Model"] = obj["model"] ?? "";
                    obj["JC Code"] = obj["jioCenter"] ?? "";
                    obj["JC Name"] = obj["jcName"] ?? "";
                    obj["Stock in units(114)"] = obj["qty"] ?? "";
                    obj["Sales In Last 90 Days"] = obj["sell90Qty"] ?? "";
                    obj["Avg per day Sales"] = obj["avgSales"] ?? "";
                    obj["No of Days"] = obj["days"] ?? "";
                    delete obj["region"];
                    delete obj["state"];
                    delete obj["zd"];
                    delete obj["zdName"];
                    delete obj["rds"];
                    delete obj["rdsName"];
                    delete obj["retailer"];
                    delete obj["retailerName"];
                    delete obj["brandDescr"];
                    delete obj["model"];
                    delete obj["maktx"];
                    delete obj["jioCenter"];
                    delete obj["jcName"];
                    delete obj["qty"];
                    delete obj["sell90Qty"];
                    delete obj["avgSales"];
                    delete obj["days"];
                    return obj;
                  });
                return csv;
              },
            }[tileName]();
        },
      }[tab]());
    },
    ARD: () => {
      ({
        "ARD": () => {
          tileName &&
            {
              other: () => {
                csv =
                  content &&
                  content.map((obj) => {
                    obj["Region"] = obj["region"] ?? "";
                    obj["State"] = obj["state"] ?? "";
                    obj["ARD ID"] = obj["zd"] ?? "";
                    obj["ARD Name"] = obj["zdName"] ?? "";
                    obj["Brand Description"] = obj["brandDescr"];
                    obj["Model"] = obj["model"] ?? "";
                    obj["Material"] = obj["maktx"] ?? "";
                    obj["JC ID"] = obj["jioCenter"] ?? "";
                    obj["JC Name"] = obj["jcName"] ?? "";
                    obj["QTY"] = obj["qty"] ?? "";
                    obj["Sales In Last 90 Days"] = obj["sell90Qty"] ?? "";
                    obj["Average Sales"] = obj["avgSales"] ?? "";
                    obj["Days"] = obj["days"] ?? "";
                    delete obj["region"];
                    delete obj["state"];
                    delete obj["zd"];
                    delete obj["zdName"];
                    delete obj["rds"];
                    delete obj["rdsName"];
                    delete obj["retailer"];
                    delete obj["retailerName"];
                    delete obj["brandDescr"];
                    delete obj["model"];
                    delete obj["maktx"];
                    delete obj["jioCenter"];
                    delete obj["jcName"];
                    delete obj["qty"];
                    delete obj["sell90Qty"];
                    delete obj["avgSales"];
                    delete obj["days"];
                    return obj;
                  });
                return csv;
              },
              partner: () => {
                csv =
                  content &&
                  content.map((obj) => {
                    obj["Region"] = obj["region"] ?? "";
                    obj["State"] = obj["state"] ?? "";
                    obj["ARD ID"] = obj["zd"] ?? "";
                    obj["ARD Name"] = obj["zdName"] ?? "";
                    obj["Model"] = obj["model"] ?? "";
                    obj["Material"] = obj["maktx"] ?? "";
                    obj["JC ID"] = obj["jioCenter"] ?? "";
                    obj["JC Name"] = obj["jcName"] ?? "";
                    obj["QTY"] = obj["qty"] ?? "";
                    obj["Sales In Last 90 Days"] = obj["sell90Qty"] ?? "";
                    obj["Average Sales"] = obj["avgSales"] ?? "";
                    obj["Days"] = obj["days"] ?? "";
                    delete obj["region"];
                    delete obj["state"];
                    delete obj["zd"];
                    delete obj["zdName"];
                    delete obj["rds"];
                    delete obj["rdsName"];
                    delete obj["retailer"];
                    delete obj["retailerName"];
                    delete obj["brandDescr"];
                    delete obj["model"];
                    delete obj["maktx"];
                    delete obj["jioCenter"];
                    delete obj["jcName"];
                    delete obj["qty"];
                    delete obj["sell90Qty"];
                    delete obj["avgSales"];
                    delete obj["days"];
                    return obj;
                  });
                return csv;
              },
            }[tileName]();
        },
        "Retailer": () => {
          tileName &&
            {
              other: () => {
                csv =
                  content &&
                  content.map((obj) => {
                    obj["Region"] = obj["region"] ?? "";
                    obj["State"] = obj["state"] ?? "";
                    obj["ARD ID"] = obj["zd"] ?? "";
                    obj["ARD Name"] = obj["zdName"] ?? "";
                    obj["Retailer ID"] = obj["retailer"] ?? "";
                    obj["Retailer Name"] = obj["retailerName"] ?? "";
                    obj["Model"] = obj["model"] ?? "";
                    obj["JC ID"] = obj["jioCenter"] ?? "";
                    obj["JC Name"] = obj["jcName"] ?? "";
                    obj["Stock in units(114)"] = obj["qty"] ?? "";
                    obj["Sales In Last 90 Days"] = obj["sell90Qty"] ?? "";
                    obj["Avg per day Sales"] = obj["avgSales"] ?? "";
                    obj["No. of Days"] = obj["days"] ?? "";
                    delete obj["region"];
                    delete obj["state"];
                    delete obj["zd"];
                    delete obj["zdName"];
                    delete obj["rds"];
                    delete obj["rdsName"];
                    delete obj["retailer"];
                    delete obj["retailerName"];
                    delete obj["brandDescr"];
                    delete obj["model"];
                    delete obj["maktx"];
                    delete obj["jioCenter"];
                    delete obj["jcName"];
                    delete obj["qty"];
                    delete obj["sell90Qty"];
                    delete obj["avgSales"];
                    delete obj["days"];
                    return obj;
                  });
                return csv;
              },
              partner: () => {
                csv =
                  content &&
                  content.map((obj) => {
                    obj["Region"] = obj["region"] ?? "";
                    obj["State"] = obj["state"] ?? "";
                    obj["ARD ID"] = obj["zd"] ?? "";
                    obj["ARD Name"] = obj["zdName"] ?? "";
                    obj["Retailer ID"] = obj["retailer"] ?? "";
                    obj["Retailer Name"] = obj["retailerName"] ?? "";
                    obj["Model"] = obj["model"] ?? "";
                    obj["JC ID"] = obj["jioCenter"] ?? "";
                    obj["JC Name"] = obj["jcName"] ?? "";
                    obj["Stock in units(114)"] = obj["qty"] ?? "";
                    obj["Sales In Last 90 Days"] = obj["sell90Qty"] ?? "";
                    obj["Avg per day Sales"] = obj["avgSales"] ?? "";
                    obj["No. of Days"] = obj["days"] ?? "";
                    delete obj["region"];
                    delete obj["state"];
                    delete obj["zd"];
                    delete obj["zdName"];
                    delete obj["rds"];
                    delete obj["rdsName"];
                    delete obj["retailer"];
                    delete obj["retailerName"];
                    delete obj["brandDescr"];
                    delete obj["model"];
                    delete obj["maktx"];
                    delete obj["jioCenter"];
                    delete obj["jcName"];
                    delete obj["qty"];
                    delete obj["sell90Qty"];
                    delete obj["avgSales"];
                    delete obj["days"];
                    return obj;
                  });
                return csv;
              },
            }[tileName]();
        },
      }[tab]());
    },
    MARD: () => {
      ({
        "MARD": () => {
          tileName &&
            {
              other: () => {
                csv =
                  content &&
                  content.map((obj) => {
                    obj["Region"] = obj["region"] ?? "";
                    obj["State"] = obj["state"] ?? "";
                    obj["MARD Code"] = obj["zd"] ?? "";
                    obj["MARD Name"] = obj["zdName"] ?? "";
                    obj["Brand Description"] = obj["brandDescr"];
                    obj["Model"] = obj["model"] ?? "";
                    obj["JC Code"] = obj["jioCenter"] ?? "";
                    obj["JC Name"] = obj["jcName"] ?? "";
                    obj["QTY"] = obj["qty"] ?? "";
                    obj["Sales In Last 90 Days"] = obj["sell90Qty"] ?? "";
                    obj["Average Sales"] = obj["avgSales"] ?? "";
                    obj["No. of Days"] = obj["days"] ?? "";
                    delete obj["region"];
                    delete obj["state"];
                    delete obj["zd"];
                    delete obj["zdName"];
                    delete obj["rds"];
                    delete obj["rdsName"];
                    delete obj["retailer"];
                    delete obj["retailerName"];
                    delete obj["brandDescr"];
                    delete obj["model"];
                    delete obj["maktx"];
                    delete obj["jioCenter"];
                    delete obj["jcName"];
                    delete obj["qty"];
                    delete obj["sell90Qty"];
                    delete obj["avgSales"];
                    delete obj["days"];
                    return obj;
                  });
                return csv;
              },
              partner: () => {
                csv =
                  content &&
                  content.map((obj) => {
                    obj["Region"] = obj["region"] ?? "";
                    obj["State"] = obj["state"] ?? "";
                    obj["ARD ID"] = obj["zd"] ?? "";
                    obj["ARD Name"] = obj["zdName"] ?? "";
                    obj["Model"] = obj["model"] ?? "";
                    obj["Material"] = obj["maktx"] ?? "";
                    obj["JC ID"] = obj["jioCenter"] ?? "";
                    obj["JC Name"] = obj["jcName"] ?? "";
                    obj["QTY"] = obj["qty"] ?? "";
                    obj["Sales In Last 90 Days"] = obj["sell90Qty"] ?? "";
                    obj["Average Sales"] = obj["avgSales"] ?? "";
                    obj["Days"] = obj["days"] ?? "";
                    delete obj["region"];
                    delete obj["state"];
                    delete obj["zd"];
                    delete obj["zdName"];
                    delete obj["rds"];
                    delete obj["rdsName"];
                    delete obj["retailer"];
                    delete obj["retailerName"];
                    delete obj["brandDescr"];
                    delete obj["model"];
                    delete obj["maktx"];
                    delete obj["jioCenter"];
                    delete obj["jcName"];
                    delete obj["qty"];
                    delete obj["sell90Qty"];
                    delete obj["avgSales"];
                    delete obj["days"];
                    return obj;
                  });
                return csv;
              },
            }[tileName]();
        },
        "Retailer": () => {
          tileName &&
            {
              other: () => {
                csv =
                  content &&
                  content.map((obj) => {
                    obj["Region"] = obj["region"] ?? "";
                    obj["State"] = obj["state"] ?? "";
                    obj["MARD Code"] = obj["zd"] ?? "";
                    obj["MARD Name"] = obj["zdName"] ?? "";
                    obj["Retailer ID"] = obj["retailer"] ?? "";
                    obj["Retailer Name"] = obj["retailerName"] ?? "";
                    obj["Model"] = obj["model"] ?? "";
                    obj["JC Code"] = obj["jioCenter"] ?? "";
                    obj["JC Name"] = obj["jcName"] ?? "";
                    obj["Stock in units"] = obj["qty"] ?? "";
                    obj["Sales In Last 90 Days"] = obj["sell90Qty"] ?? "";
                    obj["Avg per day Sales"] = obj["avgSales"] ?? "";
                    obj["No. of Days"] = obj["days"] ?? "";
                    delete obj["region"];
                    delete obj["state"];
                    delete obj["zd"];
                    delete obj["zdName"];
                    delete obj["rds"];
                    delete obj["rdsName"];
                    delete obj["retailer"];
                    delete obj["retailerName"];
                    delete obj["brandDescr"];
                    delete obj["model"];
                    delete obj["maktx"];
                    delete obj["jioCenter"];
                    delete obj["jcName"];
                    delete obj["qty"];
                    delete obj["sell90Qty"];
                    delete obj["avgSales"];
                    delete obj["days"];
                    return obj;
                  });
                return csv;
              },
              partner: () => {
                csv =
                  content &&
                  content.map((obj) => {
                    obj["Region"] = obj["region"] ?? "";
                    obj["State"] = obj["state"] ?? "";
                    obj["ARD ID"] = obj["zd"] ?? "";
                    obj["ARD Name"] = obj["zdName"] ?? "";
                    obj["Retailer ID"] = obj["retailer"] ?? "";
                    obj["Retailer Name"] = obj["retailerName"] ?? "";
                    obj["Model"] = obj["model"] ?? "";
                    obj["JC ID"] = obj["jioCenter"] ?? "";
                    obj["JC Name"] = obj["jcName"] ?? "";
                    obj["Stock in units(114)"] = obj["qty"] ?? "";
                    obj["Sales In Last 90 Days"] = obj["sell90Qty"] ?? "";
                    obj["Avg per day Sales"] = obj["avgSales"] ?? "";
                    obj["No. of Days"] = obj["days"] ?? "";
                    delete obj["region"];
                    delete obj["state"];
                    delete obj["zd"];
                    delete obj["zdName"];
                    delete obj["rds"];
                    delete obj["rdsName"];
                    delete obj["retailer"];
                    delete obj["retailerName"];
                    delete obj["brandDescr"];
                    delete obj["model"];
                    delete obj["maktx"];
                    delete obj["jioCenter"];
                    delete obj["jcName"];
                    delete obj["qty"];
                    delete obj["sell90Qty"];
                    delete obj["avgSales"];
                    delete obj["days"];
                    return obj;
                  });
                return csv;
              },
            }[tileName]();
        },
      }[tab]());
    },
    RZD: () => {
      ({
        "RZD": () => {
          tileName &&
            {
              other: () => {
                csv =
                  content &&
                  content.map((obj) => {
                    obj["Region"] = obj["region"] ?? "";
                    obj["State Name"] = obj["state"] ?? "";
                    obj["RZD Code"] = obj["zd"] ?? "";
                    obj["RZD Name"] = obj["zdName"] ?? "";
                    obj["Brand"] = obj["brandDescr"];
                    obj["Model"] = obj["model"] ?? "";
                    obj["QTY"] = obj["qty"] ?? "";
                    obj["Sales In Last 90 Days"] = obj["sell90Qty"] ?? "";
                    obj["Average Sales"] = obj["avgSales"] ?? "";
                    obj["No. of Days"] = obj["days"] ?? "";
                    delete obj["region"];
                    delete obj["state"];
                    delete obj["zd"];
                    delete obj["zdName"];
                    delete obj["rds"];
                    delete obj["rdsName"];
                    delete obj["retailer"];
                    delete obj["retailerName"];
                    delete obj["brandDescr"];
                    delete obj["model"];
                    delete obj["maktx"];
                    delete obj["jioCenter"];
                    delete obj["jcName"];
                    delete obj["qty"];
                    delete obj["sell90Qty"];
                    delete obj["avgSales"];
                    delete obj["days"];
                    return obj;
                  });
                return csv;
              },
              Accessories: () => {
                csv =
                  content &&
                  content.map((obj) => {
                    obj["Region"] = obj["region"] ?? "";
                    obj["State Name"] = obj["state"] ?? "";
                    obj["RZD Code"] = obj["zd"] ?? "";
                    obj["RZD Name"] = obj["zdName"] ?? "";
                    obj["Retailer ID"] = obj["retailer"] ?? "";
                    obj["Retailer Name"] = obj["retailerName"] ?? "";
                    obj["Brand"] = obj["brandDescr"];
                    obj["Model"] = obj["model"] ?? "";
                    obj["Stock in units"] = obj["qty"] ?? "";
                    obj["Sales In Last 90 Days"] = obj["sell90Qty"] ?? "";
                    obj["Average Sales"] = obj["avgSales"] ?? "";
                    obj["No. of Days"] = obj["days"] ?? "";
                    delete obj["region"];
                    delete obj["state"];
                    delete obj["zd"];
                    delete obj["zdName"];
                    delete obj["rds"];
                    delete obj["rdsName"];
                    delete obj["retailer"];
                    delete obj["retailerName"];
                    delete obj["brandDescr"];
                    delete obj["model"];
                    delete obj["maktx"];
                    delete obj["jioCenter"];
                    delete obj["jcName"];
                    delete obj["qty"];
                    delete obj["sell90Qty"];
                    delete obj["avgSales"];
                    delete obj["days"];
                    return obj;
                  });
                return csv;
              },
              partner: () => {
                csv =
                  content &&
                  content.map((obj) => {
                    obj["Region"] = obj["region"] ?? "";
                    obj["State Name"] = obj["state"] ?? "";
                    obj["RZD Code"] = obj["zd"] ?? "";
                    obj["RZD Name"] = obj["zdName"] ?? "";
                    obj["Brand"] = obj["brandDescr"];
                    obj["Model"] = obj["model"] ?? "";
                    obj["Stock in units"] = obj["qty"] ?? "";
                    obj["Sales In Last 90 Days"] = obj["sell90Qty"] ?? "";
                    obj["Average Sales"] = obj["avgSales"] ?? "";
                    obj["No. of Days"] = obj["days"] ?? "";
                    delete obj["region"];
                    delete obj["state"];
                    delete obj["zd"];
                    delete obj["zdName"];
                    delete obj["rds"];
                    delete obj["rdsName"];
                    delete obj["retailer"];
                    delete obj["retailerName"];
                    delete obj["brandDescr"];
                    delete obj["model"];
                    delete obj["maktx"];
                    delete obj["jioCenter"];
                    delete obj["jcName"];
                    delete obj["qty"];
                    delete obj["sell90Qty"];
                    delete obj["avgSales"];
                    delete obj["days"];
                    return obj;
                  });
                return csv;
              },
            }[tileName]();
        },
        "Retailer": () => {
          tileName &&
            {
              other: () => {
                csv =
                  content &&
                  content.map((obj) => {
                    obj["Region"] = obj["region"] ?? "";
                    obj["State Name"] = obj["state"] ?? "";
                    obj["RZD Code"] = obj["zd"] ?? "";
                    obj["RZD Name"] = obj["zdName"] ?? "";
                    obj["Retailer ID"] = obj["retailer"] ?? "";
                    obj["Retailer Name"] = obj["retailerName"] ?? "";
                    obj["Brand"] = obj["brandDescr"];
                    obj["Model"] = obj["model"] ?? "";
                    obj["Stock in units"] = obj["qty"] ?? "";
                    obj["Sales In Last 90 Days"] = obj["sell90Qty"] ?? "";
                    obj["Average Sales"] = obj["avgSales"] ?? "";
                    obj["No. of Days"] = obj["days"] ?? "";
                    delete obj["region"];
                    delete obj["state"];
                    delete obj["zd"];
                    delete obj["zdName"];
                    delete obj["rds"];
                    delete obj["rdsName"];
                    delete obj["retailer"];
                    delete obj["retailerName"];
                    delete obj["brandDescr"];
                    delete obj["model"];
                    delete obj["maktx"];
                    delete obj["jioCenter"];
                    delete obj["jcName"];
                    delete obj["qty"];
                    delete obj["sell90Qty"];
                    delete obj["avgSales"];
                    delete obj["days"];
                    return obj;
                  });
                return csv;
              },
              Accessories: () => {
                csv =
                  content &&
                  content.map((obj) => {
                    obj["Region"] = obj["region"] ?? "";
                    obj["State Name"] = obj["state"] ?? "";
                    obj["RZD Code"] = obj["zd"] ?? "";
                    obj["RZD Name"] = obj["zdName"] ?? "";
                    obj["Retailer ID"] = obj["retailer"] ?? "";
                    obj["Retailer Name"] = obj["retailerName"] ?? "";
                    obj["Brand"] = obj["brandDescr"];
                    obj["Model"] = obj["model"] ?? "";
                    obj["Stock in units"] = obj["qty"] ?? "";
                    obj["Sales In Last 90 Days"] = obj["sell90Qty"] ?? "";
                    obj["Average Sales"] = obj["avgSales"] ?? "";
                    obj["No. of Days"] = obj["days"] ?? "";
                    delete obj["region"];
                    delete obj["state"];
                    delete obj["zd"];
                    delete obj["zdName"];
                    delete obj["rds"];
                    delete obj["rdsName"];
                    delete obj["retailer"];
                    delete obj["retailerName"];
                    delete obj["brandDescr"];
                    delete obj["model"];
                    delete obj["maktx"];
                    delete obj["jioCenter"];
                    delete obj["jcName"];
                    delete obj["qty"];
                    delete obj["sell90Qty"];
                    delete obj["avgSales"];
                    delete obj["days"];
                    return obj;
                  });
                return csv;
              },
              partner: () => {
                csv =
                  content &&
                  content.map((obj) => {
                    obj["Region"] = obj["region"] ?? "";
                    obj["State Name"] = obj["state"] ?? "";
                    obj["JC Code"] = obj["jcCode"] ?? "";
                    obj["JC Name"] = obj["jcName"] ?? "";
                    obj["RZD Code"] = obj["zd"] ?? "";
                    obj["RZD Name"] = obj["zdName"] ?? "";
                    obj["Retailer ID"] = obj["retailer"] ?? "";
                    obj["Retailer Name"] = obj["retailerName"] ?? "";
                    obj["Model"] = obj["model"] ?? "";
                    obj["Stock in units"] = obj["qty"] ?? "";
                    obj["Sales In Last 90 Days"] = obj["sell90Qty"] ?? "";
                    obj["Average Sales"] = obj["avgSales"] ?? "";
                    obj["No. of Days"] = obj["days"] ?? "";
                    delete obj["region"];
                    delete obj["state"];
                    delete obj["zd"];
                    delete obj["zdName"];
                    delete obj["rds"];
                    delete obj["rdsName"];
                    delete obj["retailer"];
                    delete obj["retailerName"];
                    delete obj["brandDescr"];
                    delete obj["model"];
                    delete obj["maktx"];
                    delete obj["jioCenter"];
                    delete obj["jcName"];
                    delete obj["jcCode"];
                    delete obj["qty"];
                    delete obj["sell90Qty"];
                    delete obj["avgSales"];
                    delete obj["days"];
                    return obj;
                  });
                return csv;
              },
            }[tileName]();
        },
      }[tab]());
    },
    END: () => {
      ({
        "ED": () => {
          tileName &&
            {
              Accessories: () => {
                csv =
                  content &&
                  content.map((obj) => {
                    obj["Region"] = obj["region"] ?? "";
                    obj["State Name"] = obj["state"] ?? "";
                    obj["ED Code"] = obj["zd"] ?? "";
                    obj["ED Name"] = obj["zdName"] ?? "";
                    obj["Brand Description"] = obj["brandDescr"] ?? "";
                    obj["Material"] = obj["maktx"] ?? "";
                    obj["JC Code"] = obj["jioCenter"] ?? "";
                    obj["JC Name"] = obj["jcName"] ?? "";
                    obj["Stock in units"] = obj["qty"] ?? "";
                    obj["Sales In Last 90 Days"] = obj["sell90Qty"] ?? "";
                    obj["Average per day Sales"] = obj["avgSales"] ?? "";
                    obj["No. of Days"] = obj["days"] ?? "";
                    delete obj["region"];
                    delete obj["state"];
                    delete obj["zd"];
                    delete obj["zdName"];
                    delete obj["rds"];
                    delete obj["rdsName"];
                    delete obj["retailer"];
                    delete obj["retailerName"];
                    delete obj["brandDescr"];
                    delete obj["model"];
                    delete obj["maktx"];
                    delete obj["jioCenter"];
                    delete obj["jcName"];
                    delete obj["qty"];
                    delete obj["sell90Qty"];
                    delete obj["avgSales"];
                    delete obj["days"];
                    return obj;
                  });
                return csv;
              },
              other: () => {
                csv =
                  content &&
                  content.map((obj) => {
                    obj["Region"] = obj["region"] ?? "";
                    obj["State Name"] = obj["state"] ?? "";
                    obj["ED Code"] = obj["zd"] ?? "";
                    obj["ED Name"] = obj["zdName"] ?? "";
                    obj["Brand Description"] = obj["brandDescr"] ?? "";
                    obj["Model"] = obj["model"] ?? "";
                    obj["JC Code"] = obj["jioCenter"] ?? "";
                    obj["JC Name"] = obj["jcName"] ?? "";
                    obj["Stock in units"] = obj["qty"] ?? "";
                    obj["Sales In Last 90 Days"] = obj["sell90Qty"] ?? "";
                    obj["Average per day Sales"] = obj["avgSales"] ?? "";
                    obj["No. of Days"] = obj["days"] ?? "";
                    delete obj["region"];
                    delete obj["state"];
                    delete obj["zd"];
                    delete obj["zdName"];
                    delete obj["rds"];
                    delete obj["rdsName"];
                    delete obj["retailer"];
                    delete obj["retailerName"];
                    delete obj["brandDescr"];
                    delete obj["model"];
                    delete obj["maktx"];
                    delete obj["jioCenter"];
                    delete obj["jcName"];
                    delete obj["qty"];
                    delete obj["sell90Qty"];
                    delete obj["avgSales"];
                    delete obj["days"];
                    return obj;
                  });
                return csv;
              },
              partner: () => {
                csv =
                  content &&
                  content.map((obj) => {
                    obj["Region"] = obj["region"] ?? "";
                    obj["State Name"] = obj["state"] ?? "";
                    obj["ED Code"] = obj["zd"] ?? "";
                    obj["ED Name"] = obj["zdName"] ?? "";
                    obj["Brand Description"] = obj["brandDescr"] ?? "";
                    obj["Model"] = obj["model"] ?? "";
                    obj["JC Code"] = obj["jioCenter"] ?? "";
                    obj["JC Name"] = obj["jcName"] ?? "";
                    obj["Stock in units"] = obj["qty"] ?? "";
                    obj["Sales In Last 90 Days"] = obj["sell90Qty"] ?? "";
                    obj["Average per day Sales"] = obj["avgSales"] ?? "";
                    obj["No. of Days"] = obj["days"] ?? "";
                    delete obj["region"];
                    delete obj["state"];
                    delete obj["zd"];
                    delete obj["zdName"];
                    delete obj["rds"];
                    delete obj["rdsName"];
                    delete obj["retailer"];
                    delete obj["retailerName"];
                    delete obj["brandDescr"];
                    delete obj["model"];
                    delete obj["maktx"];
                    delete obj["jioCenter"];
                    delete obj["jcName"];
                    delete obj["qty"];
                    delete obj["sell90Qty"];
                    delete obj["avgSales"];
                    delete obj["days"];
                    return obj;
                  });
                return csv;
              },
            }[tileName]();
        },
      }[tab]());
    },
    ZDMT: () => {
      ({
        "ZDMT": () => {
          tileName &&
            {
              Accessories: () => {
                csv =
                  content &&
                  content.map((obj) => {
                    obj["Region"] = obj["region"] ?? "";
                    obj["State Name"] = obj["state"] ?? "";
                    obj["ZDMT"] = obj["zd"] ?? "";
                    obj["ZDMT Name"] = obj["zdName"] ?? "";
                    obj["Brand Name"] = obj["brandDescr"] ?? "";
                    obj["Material"] = obj["maktx"] ?? "";
                    obj["Stock in units"] = obj["qty"] ?? "";
                    obj["Sales In Last 90 Days"] = obj["sell90Qty"] ?? "";
                    obj["Average per day Sales"] = obj["avgSales"] ?? "";
                    obj["No. of Days"] = obj["days"] ?? "";
                    delete obj["region"];
                    delete obj["state"];
                    delete obj["zd"];
                    delete obj["zdName"];
                    delete obj["rds"];
                    delete obj["rdsName"];
                    delete obj["retailer"];
                    delete obj["retailerName"];
                    delete obj["brandDescr"];
                    delete obj["model"];
                    delete obj["maktx"];
                    delete obj["jioCenter"];
                    delete obj["jcName"];
                    delete obj["qty"];
                    delete obj["sell90Qty"];
                    delete obj["avgSales"];
                    delete obj["days"];
                    return obj;
                  });
                return csv;
              },
              other: () => {
                csv =
                  content &&
                  content.map((obj) => {
                    obj["Region"] = obj["region"] ?? "";
                    obj["State"] = obj["state"] ?? "";
                    obj["ZDMT"] = obj["zd"] ?? "";
                    obj["ZDMT Name"] = obj["zdName"] ?? "";
                    obj["Brand"] = obj["brandDescr"] ?? "";
                    obj["Model"] = obj["model"] ?? "";
                    obj["Stock in units"] = obj["qty"] ?? "";
                    obj["Sales In Last 90 Days"] = obj["sell90Qty"] ?? "";
                    obj["Average per day Sales"] = obj["avgSales"] ?? "";
                    obj["No. of Days"] = obj["days"] ?? "";
                    delete obj["region"];
                    delete obj["state"];
                    delete obj["zd"];
                    delete obj["zdName"];
                    delete obj["rds"];
                    delete obj["rdsName"];
                    delete obj["retailer"];
                    delete obj["retailerName"];
                    delete obj["brandDescr"];
                    delete obj["model"];
                    delete obj["maktx"];
                    delete obj["jioCenter"];
                    delete obj["jcName"];
                    delete obj["qty"];
                    delete obj["sell90Qty"];
                    delete obj["avgSales"];
                    delete obj["days"];
                    return obj;
                  });
                return csv;
              },
              partner: () => {
                csv =
                  content &&
                  content.map((obj) => {
                    obj["Region"] = obj["region"] ?? "";
                    obj["State"] = obj["state"] ?? "";
                    obj["ZDMT"] = obj["zd"] ?? "";
                    obj["ZDMT Name"] = obj["zdName"] ?? "";
                    obj["Brand"] = obj["brandDescr"] ?? "";
                    obj["Model"] = obj["model"] ?? "";
                    obj["Stock in units"] = obj["qty"] ?? "";
                    obj["Sales In Last 90 Days"] = obj["sell90Qty"] ?? "";
                    obj["Average per day Sales"] = obj["avgSales"] ?? "";
                    obj["No. of Days"] = obj["days"] ?? "";
                    delete obj["region"];
                    delete obj["state"];
                    delete obj["zd"];
                    delete obj["zdName"];
                    delete obj["rds"];
                    delete obj["rdsName"];
                    delete obj["retailer"];
                    delete obj["retailerName"];
                    delete obj["brandDescr"];
                    delete obj["model"];
                    delete obj["maktx"];
                    delete obj["jioCenter"];
                    delete obj["jcName"];
                    delete obj["qty"];
                    delete obj["sell90Qty"];
                    delete obj["avgSales"];
                    delete obj["days"];
                    return obj;
                  });
                return csv;
              },
            }[tileName]();
        },
        "Chains": () => {
          tileName &&
            {
              Accessories: () => {
                csv =
                  content &&
                  content.map((obj) => {
                    obj["Region"] = obj["region"] ?? "";
                    obj["State Name"] = obj["state"] ?? "";
                    obj["ZDMT"] = obj["zd"] ?? "";
                    obj["ZDMT Name"] = obj["zdName"] ?? "";
                    obj["CHAIN Code"] = obj["rds"] ?? "";
                    obj["CHAIN Name"] = obj["rdsName"] ?? "";
                    obj["Stock in units"] = obj["qty"] ?? "";
                    obj["Sales In Last 90 Days"] = obj["sell90Qty"] ?? "";
                    obj["Average per day Sales"] = obj["avgSales"] ?? "";
                    obj["No. of Days"] = obj["days"] ?? "";
                    delete obj["region"];
                    delete obj["state"];
                    delete obj["zd"];
                    delete obj["zdName"];
                    delete obj["rds"];
                    delete obj["rdsName"];
                    delete obj["retailer"];
                    delete obj["retailerName"];
                    delete obj["brandDescr"];
                    delete obj["model"];
                    delete obj["maktx"];
                    delete obj["jioCenter"];
                    delete obj["jcName"];
                    delete obj["qty"];
                    delete obj["sell90Qty"];
                    delete obj["avgSales"];
                    delete obj["days"];
                    return obj;
                  });
                return csv;
              },
              other: () => {
                csv =
                  content &&
                  content.map((obj) => {
                    obj["Region"] = obj["region"] ?? "";
                    obj["State Name"] = obj["state"] ?? "";
                    obj["ZDMT"] = obj["zd"] ?? "";
                    obj["ZDMT Name"] = obj["zdName"] ?? "";
                    obj["CHAIN Code"] = obj["rds"] ?? "";
                    obj["CHAIN Name"] = obj["rdsName"] ?? "";
                    obj["Stock in units"] = obj["qty"] ?? "";
                    obj["Sales In Last 90 Days"] = obj["sell90Qty"] ?? "";
                    obj["Average per day Sales"] = obj["avgSales"] ?? "";
                    obj["No. of Days"] = obj["days"] ?? "";
                    delete obj["region"];
                    delete obj["state"];
                    delete obj["zd"];
                    delete obj["zdName"];
                    delete obj["rds"];
                    delete obj["rdsName"];
                    delete obj["retailer"];
                    delete obj["retailerName"];
                    delete obj["brandDescr"];
                    delete obj["model"];
                    delete obj["maktx"];
                    delete obj["jioCenter"];
                    delete obj["jcName"];
                    delete obj["qty"];
                    delete obj["sell90Qty"];
                    delete obj["avgSales"];
                    delete obj["days"];
                    return obj;
                  });
                return csv;
              },
              partner: () => {
                csv =
                  content &&
                  content.map((obj) => {
                    obj["Region"] = obj["region"] ?? "";
                    obj["State Name"] = obj["state"] ?? "";
                    obj["ZDMT"] = obj["zd"] ?? "";
                    obj["ZDMT Name"] = obj["zdName"] ?? "";
                    obj["CHAIN Code"] = obj["rds"] ?? "";
                    obj["CHAIN Name"] = obj["rdsName"] ?? "";
                    obj["Stock in units"] = obj["qty"] ?? "";
                    obj["Sales In Last 90 Days"] = obj["sell90Qty"] ?? "";
                    obj["Average per day Sales"] = obj["avgSales"] ?? "";
                    obj["Model"] = obj["model"] ?? "";
                    obj["No. of Days"] = obj["days"] ?? "";
                    delete obj["region"];
                    delete obj["state"];
                    delete obj["zd"];
                    delete obj["zdName"];
                    delete obj["rds"];
                    delete obj["rdsName"];
                    delete obj["retailer"];
                    delete obj["retailerName"];
                    delete obj["brandDescr"];
                    delete obj["model"];
                    delete obj["maktx"];
                    delete obj["jioCenter"];
                    delete obj["jcName"];
                    delete obj["qty"];
                    delete obj["sell90Qty"];
                    delete obj["avgSales"];
                    delete obj["days"];
                    return obj;
                  });
                return csv;
              },
            }[tileName]();
        },
        "Store": () => {
          tileName &&
            {
              other: () => {
                csv =
                  content &&
                  content.map((obj) => {
                    obj["Region"] = obj["region"] ?? "";
                    obj["State Name"] = obj["state"] ?? "";
                    obj["ZDMT"] = obj["zd"] ?? "";
                    obj["ZDMT Name"] = obj["zdName"] ?? "";
                    obj["CHAIN"] = obj["rds"] ?? "";
                    obj["CHAIN Name"] = obj["rdsName"] ?? "";
                    obj["STORE ID"] = obj["retailer"] ?? "";
                    obj["STORE Name"] = obj["retailerName"] ?? "";
                    obj["Model"] = obj["model"] ?? "";
                    obj["JC Code"] = obj["jioCenter"] ?? "";
                    obj["JC Name"] = obj["jcName"] ?? "";
                    obj["Stock in units"] = obj["qty"] ?? "";
                    obj["Sales In Last 90 Days"] = obj["sell90Qty"] ?? "";
                    obj["Average per day Sales"] = obj["avgSales"] ?? "";
                    obj["No. of Days"] = obj["days"] ?? "";
                    delete obj["region"];
                    delete obj["state"];
                    delete obj["zd"];
                    delete obj["zdName"];
                    delete obj["rds"];
                    delete obj["rdsName"];
                    delete obj["retailer"];
                    delete obj["retailerName"];
                    delete obj["brandDescr"];
                    delete obj["model"];
                    delete obj["maktx"];
                    delete obj["jioCenter"];
                    delete obj["jcName"];
                    delete obj["qty"];
                    delete obj["sell90Qty"];
                    delete obj["avgSales"];
                    delete obj["days"];
                    return obj;
                  });
                return csv;
              },
              Accessories: () => {
                csv =
                  content &&
                  content.map((obj) => {
                    obj["Region"] = obj["region"] ?? "";
                    obj["State Name"] = obj["state"] ?? "";
                    obj["ZDMT"] = obj["zd"] ?? "";
                    obj["ZDMT Name"] = obj["zdName"] ?? "";
                    obj["CHAIN"] = obj["rds"] ?? "";
                    obj["CHAIN Name"] = obj["rdsName"] ?? "";
                    obj["STORE ID"] = obj["retailer"] ?? "";
                    obj["STORE Name"] = obj["retailerName"] ?? "";
                    obj["Model"] = obj["model"] ?? "";
                    obj["JC Code"] = obj["jioCenter"] ?? "";
                    obj["JC Name"] = obj["jcName"] ?? "";
                    obj["Stock in units"] = obj["qty"] ?? "";
                    obj["Sales In Last 90 Days"] = obj["sell90Qty"] ?? "";
                    obj["Average per day Sales"] = obj["avgSales"] ?? "";
                    obj["No. of Days"] = obj["days"] ?? "";
                    delete obj["region"];
                    delete obj["state"];
                    delete obj["zd"];
                    delete obj["zdName"];
                    delete obj["rds"];
                    delete obj["rdsName"];
                    delete obj["retailer"];
                    delete obj["retailerName"];
                    delete obj["brandDescr"];
                    delete obj["model"];
                    delete obj["maktx"];
                    delete obj["jioCenter"];
                    delete obj["jcName"];
                    delete obj["qty"];
                    delete obj["sell90Qty"];
                    delete obj["avgSales"];
                    delete obj["days"];
                    return obj;
                  });
                return csv;
              },
              partner: () => {
                csv =
                  content &&
                  content.map((obj) => {
                    obj["Region"] = obj["region"] ?? "";
                    obj["State Name"] = obj["state"] ?? "";
                    obj["ZDMT"] = obj["zd"] ?? "";
                    obj["ZDMT Name"] = obj["zdName"] ?? "";
                    obj["CHAIN"] = obj["rds"] ?? "";
                    obj["CHAIN Name"] = obj["rdsName"] ?? "";
                    obj["STORE ID"] = obj["retailer"] ?? "";
                    obj["STORE Name"] = obj["retailerName"] ?? "";
                    obj["Model"] = obj["model"] ?? "";
                    obj["Stock in units"] = obj["qty"] ?? "";
                    obj["Sales In Last 90 Days"] = obj["sell90Qty"] ?? "";
                    obj["Average per day Sales"] = obj["avgSales"] ?? "";
                    obj["No. of Days"] = obj["days"] ?? "";
                    delete obj["region"];
                    delete obj["state"];
                    delete obj["zd"];
                    delete obj["zdName"];
                    delete obj["rds"];
                    delete obj["rdsName"];
                    delete obj["retailer"];
                    delete obj["retailerName"];
                    delete obj["brandDescr"];
                    delete obj["model"];
                    delete obj["maktx"];
                    delete obj["jioCenter"];
                    delete obj["jcName"];
                    delete obj["qty"];
                    delete obj["sell90Qty"];
                    delete obj["avgSales"];
                    delete obj["days"];
                    return obj;
                  });
                return csv;
              },
            }[tileName]();
        },
      }[tab]());
    },
    CHAIN: () => {
      ({
        "ZDMTC": () => {
          tileName &&
            {
              other: () => {
                csv =
                  content &&
                  content.map((obj) => {
                    obj["Region"] = obj["region"] ?? "";
                    obj["State Name"] = obj["state"] ?? "";
                    obj["ZDMT Code"] = obj["zd"] ?? "";
                    obj["ZDMT Name"] = obj["zdName"] ?? "";
                    obj["CHAIN Code"] = obj["rds"] ?? "";
                    obj["CHAIN Name"] = obj["rdsName"] ?? "";
                    obj["Brand"] = obj["brandDescr"] ?? "";
                    obj["Model"] = obj["model"] ?? "";
                    obj["Stock in units"] = obj["qty"] ?? "";
                    obj["Sales In Last 90 Days"] = obj["sell90Qty"] ?? "";
                    obj["Average per day Sales"] = obj["avgSales"] ?? "";
                    obj["No. of Days"] = obj["days"] ?? "";
                    delete obj["region"];
                    delete obj["state"];
                    delete obj["zd"];
                    delete obj["zdName"];
                    delete obj["rds"];
                    delete obj["rdsName"];
                    delete obj["retailer"];
                    delete obj["retailerName"];
                    delete obj["brandDescr"];
                    delete obj["model"];
                    delete obj["maktx"];
                    delete obj["jioCenter"];
                    delete obj["jcName"];
                    delete obj["qty"];
                    delete obj["sell90Qty"];
                    delete obj["avgSales"];
                    delete obj["days"];
                    return obj;
                  });
                return csv;
              },
              Accessories: () => {
                csv =
                  content &&
                  content.map((obj) => {
                    obj["Region"] = obj["region"] ?? "";
                    obj["State Name"] = obj["state"] ?? "";
                    obj["ZDMT Code"] = obj["zd"] ?? "";
                    obj["ZDMT Name"] = obj["zdName"] ?? "";
                    obj["CHAIN Code"] = obj["rds"] ?? "";
                    obj["CHAIN Name"] = obj["rdsName"] ?? "";
                    obj["Brand"] = obj["brandDescr"] ?? "";
                    obj["Material"] = obj["maktx"] ?? "";
                    obj["Stock in units"] = obj["qty"] ?? "";
                    obj["Sales In Last 90 Days"] = obj["sell90Qty"] ?? "";
                    obj["Average per day Sales"] = obj["avgSales"] ?? "";
                    obj["No. of Days"] = obj["days"] ?? "";
                    delete obj["region"];
                    delete obj["state"];
                    delete obj["zd"];
                    delete obj["zdName"];
                    delete obj["rds"];
                    delete obj["rdsName"];
                    delete obj["retailer"];
                    delete obj["retailerName"];
                    delete obj["brandDescr"];
                    delete obj["model"];
                    delete obj["maktx"];
                    delete obj["jioCenter"];
                    delete obj["jcName"];
                    delete obj["qty"];
                    delete obj["sell90Qty"];
                    delete obj["avgSales"];
                    delete obj["days"];
                    return obj;
                  });
                return csv;
              },
              partner: () => {
                content &&
                  content.map((obj) => {
                    obj["Region"] = obj["region"] ?? "";
                    obj["State Name"] = obj["state"] ?? "";
                    obj["ZDMT Code"] = obj["zd"] ?? "";
                    obj["ZDMT Name"] = obj["zdName"] ?? "";
                    obj["CHAIN Code"] = obj["rds"] ?? "";
                    obj["CHAIN Name"] = obj["rdsName"] ?? "";
                    obj["Model"] = obj["model"] ?? "";
                    obj["Stock in units"] = obj["qty"] ?? "";
                    obj["Sales In Last 90 Days"] = obj["sell90Qty"] ?? "";
                    obj["Average per day Sales"] = obj["avgSales"] ?? "";
                    obj["No. of Days"] = obj["days"] ?? "";
                    delete obj["region"];
                    delete obj["state"];
                    delete obj["zd"];
                    delete obj["zdName"];
                    delete obj["rds"];
                    delete obj["rdsName"];
                    delete obj["retailer"];
                    delete obj["retailerName"];
                    delete obj["brandDescr"];
                    delete obj["model"];
                    delete obj["maktx"];
                    delete obj["jioCenter"];
                    delete obj["jcName"];
                    delete obj["qty"];
                    delete obj["sell90Qty"];
                    delete obj["avgSales"];
                    delete obj["days"];
                    return obj;
                  });
                return csv;
              },
            }[tileName]();
        },
        "Store": () => {
          tileName &&
            {
              other: () => {
                csv =
                  content &&
                  content.map((obj) => {
                    obj["Region"] = obj["region"] ?? "";
                    obj["State"] = obj["state"] ?? "";
                    obj["ZDMT"] = obj["zd"] ?? "";
                    obj["ZDMT Name"] = obj["zdName"] ?? "";
                    obj["CHAIN"] = obj["rds"] ?? "";
                    obj["CHAIN Name"] = obj["rdsName"] ?? "";
                    obj["STORE ID"] = obj["retailer"] ?? "";
                    obj["STORE Name"] = obj["retailerName"] ?? "";
                    obj["Model"] = obj["model"] ?? "";
                    obj["JC Code"] = obj["jioCenter"] ?? "";
                    obj["JC Name"] = obj["jcName"] ?? "";
                    obj["Stock in units"] = obj["qty"] ?? "";
                    obj["Sales In Last 90 Days"] = obj["sell90Qty"] ?? "";
                    obj["Average per day Sales"] = obj["avgSales"] ?? "";
                    obj["No. of Days"] = obj["days"] ?? "";
                    delete obj["region"];
                    delete obj["state"];
                    delete obj["zd"];
                    delete obj["zdName"];
                    delete obj["rds"];
                    delete obj["rdsName"];
                    delete obj["retailer"];
                    delete obj["retailerName"];
                    delete obj["brandDescr"];
                    delete obj["model"];
                    delete obj["maktx"];
                    delete obj["jioCenter"];
                    delete obj["jcName"];
                    delete obj["qty"];
                    delete obj["sell90Qty"];
                    delete obj["avgSales"];
                    delete obj["days"];
                    return obj;
                  });
                return csv;
              },
              Accessories: () => {
                csv =
                  content &&
                  content.map((obj) => {
                    obj["Region"] = obj["region"] ?? "";
                    obj["State"] = obj["state"] ?? "";
                    obj["ZDMT"] = obj["zd"] ?? "";
                    obj["ZDMT Name"] = obj["zdName"] ?? "";
                    obj["CHAIN"] = obj["rds"] ?? "";
                    obj["CHAIN Name"] = obj["rdsName"] ?? "";
                    obj["STORE ID"] = obj["retailer"] ?? "";
                    obj["STORE Name"] = obj["retailerName"] ?? "";
                    obj["Model"] = obj["model"] ?? "";
                    obj["JC Code"] = obj["jioCenter"] ?? "";
                    obj["JC Name"] = obj["jcName"] ?? "";
                    obj["Stock in units"] = obj["qty"] ?? "";
                    obj["Sales In Last 90 Days"] = obj["sell90Qty"] ?? "";
                    obj["Average per day Sales"] = obj["avgSales"] ?? "";
                    obj["No. of Days"] = obj["days"] ?? "";
                    delete obj["region"];
                    delete obj["state"];
                    delete obj["zd"];
                    delete obj["zdName"];
                    delete obj["rds"];
                    delete obj["rdsName"];
                    delete obj["retailer"];
                    delete obj["retailerName"];
                    delete obj["brandDescr"];
                    delete obj["model"];
                    delete obj["maktx"];
                    delete obj["jioCenter"];
                    delete obj["jcName"];
                    delete obj["qty"];
                    delete obj["sell90Qty"];
                    delete obj["avgSales"];
                    delete obj["days"];
                    return obj;
                  });
                return csv;
              },
              partner: () => {
                csv =
                  content &&
                  content.map((obj) => {
                    obj["Region"] = obj["region"] ?? "";
                    obj["State"] = obj["state"] ?? "";
                    obj["ZDMT"] = obj["zd"] ?? "";
                    obj["ZDMT Name"] = obj["zdName"] ?? "";
                    obj["CHAIN"] = obj["rds"] ?? "";
                    obj["CHAIN Name"] = obj["rdsName"] ?? "";
                    obj["STORE ID"] = obj["retailer"] ?? "";
                    obj["STORE Name"] = obj["retailerName"] ?? "";
                    obj["Model"] = obj["model"] ?? "";
                    obj["Stock in units"] = obj["qty"] ?? "";
                    obj["Sales In Last 90 Days"] = obj["sell90Qty"] ?? "";
                    obj["Average per day Sales"] = obj["avgSales"] ?? "";
                    obj["No. of Days"] = obj["days"] ?? "";
                    delete obj["region"];
                    delete obj["state"];
                    delete obj["zd"];
                    delete obj["zdName"];
                    delete obj["rds"];
                    delete obj["rdsName"];
                    delete obj["retailer"];
                    delete obj["retailerName"];
                    delete obj["brandDescr"];
                    delete obj["model"];
                    delete obj["maktx"];
                    delete obj["jioCenter"];
                    delete obj["jcName"];
                    delete obj["qty"];
                    delete obj["sell90Qty"];
                    delete obj["avgSales"];
                    delete obj["days"];
                    return obj;
                  });
                return csv;
              },
            }[tileName]();
        },
      }[tab]());
    },
    DT: () => {
      ({
        "DT": () => {
          tileName &&
            {
              other: () => {
                csv =
                  content &&
                  content.map((obj) => {
                    obj["Region"] = obj["region"] ?? "";
                    obj["State"] = obj["state"] ?? "";
                    obj["DT Code"] = obj["zd"] ?? "";
                    obj["DT Name"] = obj["zdName"] ?? "";
                    obj["Brand descriptor"] = obj["brandDescr"] ?? "";
                    obj["Model"] = obj["model"] ?? "";
                    obj["QTY"] = obj["qty"] ?? "";
                    obj["Sales In Last 90 Days"] = obj["sell90Qty"] ?? "";
                    obj["Average per day Sales"] = obj["avgSales"] ?? "";
                    obj["No. of Days"] = obj["days"] ?? "";
                    delete obj["region"];
                    delete obj["state"];
                    delete obj["zd"];
                    delete obj["zdName"];
                    delete obj["rds"];
                    delete obj["rdsName"];
                    delete obj["retailer"];
                    delete obj["retailerName"];
                    delete obj["brandDescr"];
                    delete obj["model"];
                    delete obj["maktx"];
                    delete obj["jioCenter"];
                    delete obj["jcName"];
                    delete obj["qty"];
                    delete obj["sell90Qty"];
                    delete obj["avgSales"];
                    delete obj["days"];
                    return obj;
                  });
                return csv;
              },
              Accessories: () => {
                csv =
                  content &&
                  content.map((obj) => {
                    obj["Region"] = obj["region"] ?? "";
                    obj["State"] = obj["state"] ?? "";
                    obj["DT Code"] = obj["zd"] ?? "";
                    obj["DT Name"] = obj["zdName"] ?? "";
                    obj["Brand descriptor"] = obj["brandDescr"] ?? "";
                    obj["Model"] = obj["model"] ?? "";
                    obj["QTY"] = obj["qty"] ?? "";
                    obj["Sales In Last 90 Days"] = obj["sell90Qty"] ?? "";
                    obj["Average per day Sales"] = obj["avgSales"] ?? "";
                    obj["No. of Days"] = obj["days"] ?? "";
                    delete obj["region"];
                    delete obj["state"];
                    delete obj["zd"];
                    delete obj["zdName"];
                    delete obj["rds"];
                    delete obj["rdsName"];
                    delete obj["retailer"];
                    delete obj["retailerName"];
                    delete obj["brandDescr"];
                    delete obj["model"];
                    delete obj["maktx"];
                    delete obj["jioCenter"];
                    delete obj["jcName"];
                    delete obj["qty"];
                    delete obj["sell90Qty"];
                    delete obj["avgSales"];
                    delete obj["days"];
                    return obj;
                  });
                return csv;
              },
              partner: () => {
                csv =
                  content &&
                  content.map((obj) => {
                    obj["Region"] = obj["region"] ?? "";
                    obj["State"] = obj["state"] ?? "";
                    obj["DT Code"] = obj["zd"] ?? "";
                    obj["DT Name"] = obj["zdName"] ?? "";
                    obj["Brand descriptor"] = obj["brandDescr"] ?? "";
                    obj["Model"] = obj["model"] ?? "";
                    obj["QTY"] = obj["qty"] ?? "";
                    obj["Sales In Last 90 Days"] = obj["sell90Qty"] ?? "";
                    obj["Average per day Sales"] = obj["avgSales"] ?? "";
                    obj["No. of Days"] = obj["days"] ?? "";
                    delete obj["region"];
                    delete obj["state"];
                    delete obj["zd"];
                    delete obj["zdName"];
                    delete obj["rds"];
                    delete obj["rdsName"];
                    delete obj["retailer"];
                    delete obj["retailerName"];
                    delete obj["brandDescr"];
                    delete obj["model"];
                    delete obj["maktx"];
                    delete obj["jioCenter"];
                    delete obj["jcName"];
                    delete obj["qty"];
                    delete obj["sell90Qty"];
                    delete obj["avgSales"];
                    delete obj["days"];
                    return obj;
                  });
                return csv;
              },
            }[tileName]();
        },
      }[tab]());
    },
    JC: () => {
      ({
        "RDS": () => {
          tileName &&
            {
              Accessories: () => {
                csv =
                  content &&
                  content.map((obj) => {
                    obj["Region"] = obj["region"] ?? "";
                    obj["State"] = obj["state"] ?? "";
                    obj["Parent Id"] = obj["parentId"] ?? "";
                    obj["Parent Name"] = obj["parentName"] ?? "";
                    obj["Partner Id"] = obj["partnerId"] ?? "";
                    obj["Partner Name"] = obj["partnerName"] ?? "";
                    obj["JC Code"] = obj["jioCenter"] ?? "";
                    obj["JC Name"] = obj["jcName"] ?? "";
                    obj["Brand Description"] = obj["brandDescr"] ?? "";
                    obj["Model"] = obj["model"] ?? "";
                    obj["Material"] = obj["matnr"] ?? "";
                    obj["Stock In Units(0)"] = obj["qty"] ?? "";
                    obj["Sales in last 90 days"] = obj["sell90Qty"] ?? "";
                    obj["Avg per day sale"] = obj["avgSales"] ?? "";
                    obj["No. of Days"] = obj["days"] ?? "";

                    delete obj["avgSales"];
                    delete obj["brandDescr"];
                    delete obj["days"];
                    delete obj["jcName"];
                    delete obj["jioCenter"];
                    delete obj["matnr"];
                    delete obj["model"];
                    delete obj["parentId"];
                    delete obj["parentName"];
                    delete obj["partnerId"];
                    delete obj["qty"];
                    delete obj["region"];
                    delete obj["sell90Qty"];
                    delete obj["state"];
                    return obj;
                  });
                return csv;
              },
              other: () => {
                csv =
                  content &&
                  content.map((obj) => {
                    obj["Region"] = obj["region"] ?? "";
                    obj["State"] = obj["state"] ?? "";
                    obj["Parent Id"] = obj["parentId"] ?? "";
                    obj["Parent Name"] = obj["parentName"] ?? "";
                    obj["Partner Id"] = obj["partnerId"] ?? "";
                    obj["Partner Name"] = obj["partnerName"] ?? "";
                    obj["JC Code"] = obj["jioCenter"] ?? "";
                    obj["JC Name"] = obj["jcName"] ?? "";
                    obj["Brand Description"] = obj["brandDescr"] ?? "";
                    obj["Model"] = obj["model"] ?? "";
                    obj["Stock In Units(0)"] = obj["qty"] ?? "";
                    obj["Sales in last 90 days"] = obj["sell90Qty"] ?? "";
                    obj["Avg per day sale"] = obj["avgSales"] ?? "";
                    obj["No. of Days"] = obj["days"] ?? "";

                    delete obj["avgSales"];
                    delete obj["brandDescr"];
                    delete obj["days"];
                    delete obj["jcName"];
                    delete obj["jioCenter"];
                    delete obj["matnr"];
                    delete obj["model"];
                    delete obj["parentId"];
                    delete obj["parentName"];
                    delete obj["partnerId"];
                    delete obj["qty"];
                    delete obj["region"];
                    delete obj["sell90Qty"];
                    delete obj["state"];
                    return obj;
                  });
                return csv;
              },
              partner: () => {
                csv =
                  content &&
                  content.map((obj) => {
                    obj["Region"] = obj["region"] ?? "";
                    obj["State"] = obj["state"] ?? "";
                    obj["ZD"] = obj["zd"] ?? "";
                    obj["ZD Name"] = obj["zdName"] ?? "";
                    obj["RDS"] = obj["rds"] ?? "";
                    obj["RDS Name"] = obj["rdsName"] ?? "";
                    obj["Model"] = obj["model"] ?? "";
                    obj["JC Code"] = obj["jioCenter"] ?? "";
                    obj["JC Name"] = obj["jcName"] ?? "";
                    obj["Stock in units"] = obj["qty"] ?? "";
                    obj["Sales in last 90 days"] = obj["sell90Qty"] ?? "";
                    obj["Avg per day sale"] = obj["avgSales"] ?? "";
                    obj["No. of Days"] = obj["days"] ?? "";
                    delete obj["region"];
                    delete obj["state"];
                    delete obj["zd"];
                    delete obj["zdName"];
                    delete obj["rds"];
                    delete obj["rdsName"];
                    delete obj["retailer"];
                    delete obj["retailerName"];
                    delete obj["brandDescr"];
                    delete obj["model"];
                    delete obj["maktx"];
                    delete obj["jioCenter"];
                    delete obj["jcName"];
                    delete obj["qty"];
                    delete obj["sell90Qty"];
                    delete obj["avgSales"];
                    delete obj["days"];
                    return obj;
                  });
                return csv;
              },
            }[tileName]();
        },
        "Retailer": () => {
          tileName &&
            {
              Accessories: () => {
                csv =
                  content &&
                  content.map((obj) => {
                    obj["Region"] = obj["region"] ?? "";
                    obj["State"] = obj["state"] ?? "";
                    obj["Parent Id"] = obj["parentId"] ?? "";
                    obj["Parent Name"] = obj["parentName"] ?? "";
                    obj["Partner Id"] = obj["partnerId"] ?? "";
                    obj["Partner Name"] = obj["partnerName"] ?? "";
                    obj["JC Code"] = obj["jioCenter"] ?? "";
                    obj["JC Name"] = obj["jcName"] ?? "";
                    obj["Brand Description"] = obj["brandDescr"] ?? "";
                    obj["Model"] = obj["model"] ?? "";
                    obj["Material"] = obj["matnr"] ?? "";
                    obj["Stock In Units(0)"] = obj["qty"] ?? "";
                    obj["Sales in last 90 days"] = obj["sell90Qty"] ?? "";
                    obj["Avg per day sale"] = obj["avgSales"] ?? "";
                    obj["No. of Days"] = obj["days"] ?? "";

                    delete obj["avgSales"];
                    delete obj["brandDescr"];
                    delete obj["days"];
                    delete obj["jcName"];
                    delete obj["jioCenter"];
                    delete obj["matnr"];
                    delete obj["model"];
                    delete obj["parentId"];
                    delete obj["parentName"];
                    delete obj["partnerId"];
                    delete obj["qty"];
                    delete obj["region"];
                    delete obj["sell90Qty"];
                    delete obj["state"];
                    return obj;
                  });
                return csv;
              },
              other: () => {
                csv =
                  content &&
                  content.map((obj) => {
                    obj["Region"] = obj["region"] ?? "";
                    obj["State"] = obj["state"] ?? "";
                    obj["Parent Id"] = obj["parentId"] ?? "";
                    obj["Parent Name"] = obj["parentName"] ?? "";
                    obj["Partner Id"] = obj["partnerId"] ?? "";
                    obj["Partner Name"] = obj["partnerName"] ?? "";
                    obj["JC Code"] = obj["jioCenter"] ?? "";
                    obj["JC Name"] = obj["jcName"] ?? "";
                    obj["Brand Description"] = obj["brandDescr"] ?? "";
                    obj["Model"] = obj["model"] ?? "";
                    obj["Stock In Units(0)"] = obj["qty"] ?? "";
                    obj["Sales in last 90 days"] = obj["sell90Qty"] ?? "";
                    obj["Avg per day sale"] = obj["avgSales"] ?? "";
                    obj["No. of Days"] = obj["days"] ?? "";

                    delete obj["avgSales"];
                    delete obj["brandDescr"];
                    delete obj["days"];
                    delete obj["jcName"];
                    delete obj["jioCenter"];
                    delete obj["matnr"];
                    delete obj["model"];
                    delete obj["parentId"];
                    delete obj["parentName"];
                    delete obj["partnerId"];
                    delete obj["qty"];
                    delete obj["region"];
                    delete obj["sell90Qty"];
                    delete obj["state"];
                    return obj;
                  });
                return csv;
              },
              partner: () => {
                csv =
                  content &&
                  content.map((obj) => {
                    obj["Region"] = obj["region"] ?? "";
                    obj["State"] = obj["state"] ?? "";
                    obj["ZD"] = obj["zd"] ?? "";
                    obj["ZD Name"] = obj["zdName"] ?? "";
                    obj["RDS"] = obj["rds"] ?? "";
                    obj["RDS Name"] = obj["rdsName"] ?? "";
                    obj["Model"] = obj["model"] ?? "";
                    obj["JC Code"] = obj["jioCenter"] ?? "";
                    obj["JC Name"] = obj["jcName"] ?? "";
                    obj["Stock in units"] = obj["qty"] ?? "";
                    obj["Sales in last 90 days"] = obj["sell90Qty"] ?? "";
                    obj["Avg per day sale"] = obj["avgSales"] ?? "";
                    obj["No. of Days"] = obj["days"] ?? "";
                    delete obj["region"];
                    delete obj["state"];
                    delete obj["zd"];
                    delete obj["zdName"];
                    delete obj["rds"];
                    delete obj["rdsName"];
                    delete obj["retailer"];
                    delete obj["retailerName"];
                    delete obj["brandDescr"];
                    delete obj["model"];
                    delete obj["maktx"];
                    delete obj["jioCenter"];
                    delete obj["jcName"];
                    delete obj["qty"];
                    delete obj["sell90Qty"];
                    delete obj["avgSales"];
                    delete obj["days"];
                    return obj;
                  });
                return csv;
              },
            }[tileName]();
        },
        "ARD": () => {
          tileName &&
            {
              Accessories: () => {
                csv =
                  content &&
                  content.map((obj) => {
                    obj["Region"] = obj["region"] ?? "";
                    obj["State"] = obj["state"] ?? "";
                    obj["Parent Id"] = obj["parentId"] ?? "";
                    obj["Parent Name"] = obj["parentName"] ?? "";
                    obj["Partner Id"] = obj["partnerId"] ?? "";
                    obj["Partner Name"] = obj["partnerName"] ?? "";
                    obj["JC Code"] = obj["jioCenter"] ?? "";
                    obj["JC Name"] = obj["jcName"] ?? "";
                    obj["Brand Description"] = obj["brandDescr"] ?? "";
                    obj["Model"] = obj["model"] ?? "";
                    obj["Material"] = obj["matnr"] ?? "";
                    obj["Stock In Units(0)"] = obj["qty"] ?? "";
                    obj["Sales in last 90 days"] = obj["sell90Qty"] ?? "";
                    obj["Avg per day sale"] = obj["avgSales"] ?? "";
                    obj["No. of Days"] = obj["days"] ?? "";

                    delete obj["avgSales"];
                    delete obj["brandDescr"];
                    delete obj["days"];
                    delete obj["jcName"];
                    delete obj["jioCenter"];
                    delete obj["matnr"];
                    delete obj["model"];
                    delete obj["parentId"];
                    delete obj["parentName"];
                    delete obj["partnerId"];
                    delete obj["qty"];
                    delete obj["region"];
                    delete obj["sell90Qty"];
                    delete obj["state"];
                    return obj;
                  });
                return csv;
              },
              other: () => {
                csv =
                  content &&
                  content.map((obj) => {
                    obj["Region"] = obj["region"] ?? "";
                    obj["State"] = obj["state"] ?? "";
                    obj["Parent Id"] = obj["parentId"] ?? "";
                    obj["Parent Name"] = obj["parentName"] ?? "";
                    obj["Partner Id"] = obj["partnerId"] ?? "";
                    obj["Partner Name"] = obj["partnerName"] ?? "";
                    obj["JC Code"] = obj["jioCenter"] ?? "";
                    obj["JC Name"] = obj["jcName"] ?? "";
                    obj["Brand Description"] = obj["brandDescr"] ?? "";
                    obj["Model"] = obj["model"] ?? "";
                    obj["Stock In Units(0)"] = obj["qty"] ?? "";
                    obj["Sales in last 90 days"] = obj["sell90Qty"] ?? "";
                    obj["Avg per day sale"] = obj["avgSales"] ?? "";
                    obj["No. of Days"] = obj["days"] ?? "";

                    delete obj["avgSales"];
                    delete obj["brandDescr"];
                    delete obj["days"];
                    delete obj["jcName"];
                    delete obj["jioCenter"];
                    delete obj["matnr"];
                    delete obj["model"];
                    delete obj["parentId"];
                    delete obj["parentName"];
                    delete obj["partnerId"];
                    delete obj["partnerName"];
                    delete obj["qty"];
                    delete obj["region"];
                    delete obj["sell90Qty"];
                    delete obj["state"];
                    return obj;
                  });
                return csv;
              },
              partner: () => {
                csv =
                  content &&
                  content.map((obj) => {
                    obj["Region"] = obj["region"] ?? "";
                    obj["State"] = obj["state"] ?? "";
                    obj["ZD"] = obj["zd"] ?? "";
                    obj["ZD Name"] = obj["zdName"] ?? "";
                    obj["RDS"] = obj["rds"] ?? "";
                    obj["RDS Name"] = obj["rdsName"] ?? "";
                    obj["Model"] = obj["model"] ?? "";
                    obj["JC Code"] = obj["jioCenter"] ?? "";
                    obj["JC Name"] = obj["jcName"] ?? "";
                    obj["Stock in units"] = obj["qty"] ?? "";
                    obj["Sales in last 90 days"] = obj["sell90Qty"] ?? "";
                    obj["Avg per day sale"] = obj["avgSales"] ?? "";
                    obj["No. of Days"] = obj["days"] ?? "";
                    delete obj["region"];
                    delete obj["state"];
                    delete obj["zd"];
                    delete obj["zdName"];
                    delete obj["rds"];
                    delete obj["rdsName"];
                    delete obj["retailer"];
                    delete obj["retailerName"];
                    delete obj["brandDescr"];
                    delete obj["model"];
                    delete obj["maktx"];
                    delete obj["jioCenter"];
                    delete obj["jcName"];
                    delete obj["qty"];
                    delete obj["sell90Qty"];
                    delete obj["avgSales"];
                    delete obj["days"];
                    return obj;
                  });
                return csv;
              },
            }[tileName]();
        },
        "MARD": () => {
          tileName &&
            {
              Accessories: () => {
                csv =
                  content &&
                  content.map((obj) => {
                    obj["Region"] = obj["region"] ?? "";
                    obj["State"] = obj["state"] ?? "";
                    obj["Parent Id"] = obj["parentId"] ?? "";
                    obj["Parent Name"] = obj["parentName"] ?? "";
                    obj["Partner Id"] = obj["partnerId"] ?? "";
                    obj["Partner Name"] = obj["partnerName"] ?? "";
                    obj["JC Code"] = obj["jioCenter"] ?? "";
                    obj["JC Name"] = obj["jcName"] ?? "";
                    obj["Brand Description"] = obj["brandDescr"] ?? "";
                    obj["Model"] = obj["model"] ?? "";
                    obj["Material"] = obj["matnr"] ?? "";
                    obj["Stock In Units(0)"] = obj["qty"] ?? "";
                    obj["Sales in last 90 days"] = obj["sell90Qty"] ?? "";
                    obj["Avg per day sale"] = obj["avgSales"] ?? "";
                    obj["No. of Days"] = obj["days"] ?? "";

                    delete obj["avgSales"];
                    delete obj["brandDescr"];
                    delete obj["days"];
                    delete obj["jcName"];
                    delete obj["jioCenter"];
                    delete obj["matnr"];
                    delete obj["model"];
                    delete obj["parentId"];
                    delete obj["parentName"];
                    delete obj["partnerId"];
                    delete obj["qty"];
                    delete obj["region"];
                    delete obj["sell90Qty"];
                    delete obj["state"];
                    return obj;
                  });
                return csv;
              },
              other: () => {
                csv =
                  content &&
                  content.map((obj) => {
                    obj["Region"] = obj["region"] ?? "";
                    obj["State"] = obj["state"] ?? "";
                    obj["Parent Id"] = obj["parentId"] ?? "";
                    obj["Parent Name"] = obj["parentName"] ?? "";
                    obj["Partner Id"] = obj["partnerId"] ?? "";
                    obj["Partner Name"] = obj["partnerName"] ?? "";
                    obj["JC Code"] = obj["jioCenter"] ?? "";
                    obj["JC Name"] = obj["jcName"] ?? "";
                    obj["Brand Description"] = obj["brandDescr"] ?? "";
                    obj["Model"] = obj["model"] ?? "";
                    obj["Stock In Units(0)"] = obj["qty"] ?? "";
                    obj["Sales in last 90 days"] = obj["sell90Qty"] ?? "";
                    obj["Avg per day sale"] = obj["avgSales"] ?? "";
                    obj["No. of Days"] = obj["days"] ?? "";

                    delete obj["avgSales"];
                    delete obj["brandDescr"];
                    delete obj["days"];
                    delete obj["jcName"];
                    delete obj["jioCenter"];
                    delete obj["matnr"];
                    delete obj["model"];
                    delete obj["parentId"];
                    delete obj["parentName"];
                    delete obj["partnerId"];
                    delete obj["partnerName"];
                    delete obj["qty"];
                    delete obj["region"];
                    delete obj["sell90Qty"];
                    delete obj["state"];
                    return obj;
                  });
                return csv;
              },
              partner: () => {
                csv =
                  content &&
                  content.map((obj) => {
                    obj["Region"] = obj["region"] ?? "";
                    obj["State"] = obj["state"] ?? "";
                    obj["ZD"] = obj["zd"] ?? "";
                    obj["ZD Name"] = obj["zdName"] ?? "";
                    obj["RDS"] = obj["rds"] ?? "";
                    obj["RDS Name"] = obj["rdsName"] ?? "";
                    obj["Model"] = obj["model"] ?? "";
                    obj["JC Code"] = obj["jioCenter"] ?? "";
                    obj["JC Name"] = obj["jcName"] ?? "";
                    obj["Stock in units"] = obj["qty"] ?? "";
                    obj["Sales in last 90 days"] = obj["sell90Qty"] ?? "";
                    obj["Avg per day sale"] = obj["avgSales"] ?? "";
                    obj["No. of Days"] = obj["days"] ?? "";
                    delete obj["region"];
                    delete obj["state"];
                    delete obj["zd"];
                    delete obj["zdName"];
                    delete obj["rds"];
                    delete obj["rdsName"];
                    delete obj["retailer"];
                    delete obj["retailerName"];
                    delete obj["brandDescr"];
                    delete obj["model"];
                    delete obj["maktx"];
                    delete obj["jioCenter"];
                    delete obj["jcName"];
                    delete obj["qty"];
                    delete obj["sell90Qty"];
                    delete obj["avgSales"];
                    delete obj["days"];
                    return obj;
                  });
                return csv;
              },
            }[tileName]();
        },
      }[tab]());
    },
  }[role]());
  return csv;
};
